import {
  Grid,
  ListSubheader,
  MenuItem,
  Paper,
  TextField,
  Typography,
  Tooltip,
  Checkbox,
  Box,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import { Component } from "react";
import Constants from "../../common/constants";
import withServices from "../../hocs/withServices";
import FileUpload from "../utils/FileUploadSecretary";
import { MuiTelInput } from "mui-tel-input";
import { Alert, AlertTitle } from "@material-ui/lab";
import AuthenticatedContent from "../../common/AuthenticatedContent";
import grantPermission from "../../helpers/grantPermission";
import "./style.css";
import ContractModal from "../abit/ContractModal";

let myRefIin = {};
let myRefName = {};
let myRefSurname = {};
let myRefNumber = {};

const studyStatuses = [
  {
    id: 1,
    label: "Платное отделение",
  },
  {
    id: 2,
    label: "Государственный грант",
  },
];

const assessments = [
  {
    value: 2,
  },
  {
    value: 3,
  },
  {
    value: 4,
  },
  {
    value: 5,
  },
];

const statuses = [
  {
    id: 1,
    label: "Платное отделение",
  },
  {
    id: 2,
    label: "Государственный грант",
  },
  {
    id: 3,
    label: "Отказать в поступлении",
  },
];



class SingleEnrolleePage extends Component {
  state = {
    iinChanged: false,
    user: {},
    emailMessage: "",
    isEditable: grantPermission("ROLE_DORMITORY") ? true : false,

    //PersonalInfo
    name: "",
    surname: "",
    patronymic: "",
    nameInLatin: "",
    surnameInLatin: "",
    phoneNumber: "",
    nationality: "",
    email: "",
    citizenship: "",
    foreignCountry: "",
    showKazakhstanFields: false,

    isMale: "true",
    graduationPlaceCity: "",
    needDorm: "",
    isMarried: "",
    isLocal: "",
    iin: "",
    residenceAddress: "",
    lifeAddress: "",
    factAddress: "",
    locality: "",
    firstParentName: "",
    firstParentSurname: "",
    firstParentPhoneNumber: "",
    firstParentPatronymic: "",
    dateOfBirth: "",
    secondParentName: "",
    secondParentSurname: "",
    secondParentPatronymic: "",
    secondParentPhoneNumber: "",
    image3x4: null,
    imageID: "",
    imagePath: "",
    socialStatus: "",
    socialStatusFile: null,
    socialStatusFileId: "",
    socialStatusPath: "",
    ruralQuote: false,

    //Document
    selectedIdentityDocumentType: "",
    selectedIdentityDocumentNumber: "",
    selectedIdentityDocumentIssueDate: "",
    selectedIdentityDocumentValidityPeriod: "",
    selectedIssuingAuthority: "",
    selectedOtherDocumentType: "",
    identityFront: "",
    identityBack: "",
    form086: "",
    documentConfirmingAvailabilityOfInternalGrantScan: "",
    pripisnoiBiletScan: "",
    //Массивы для хранения значений для списков
    academicDegrees: [],
    educationalProgramGroups: [],
    educationalPrograms: [],
    examTypes: [],
    examLanguages: [],
    languages: [],
    englishCertificateTypes: [],
    olympiadCertificateTypes: [],
    additionalCourses: [],
    financingPrograms: [],
    financialSources: [],
    quotas: [],
    educationInstitutionTypes: [],
    countries: [],
    localityTypes: [],
    localities: [],
    distinctionMarkTypes: [],
    socialStatusTypes: [],
    regions: [],
    residencePlaces: [],
    lifePlaces: [],
    schoolPlaces: [],
    schools: [],
    documents: [],
    institutions: [],
    //Education
    selectedCountry: "",
    selectedLanguage: "",
    selectedKzGraduationLocalityType: "",
    selectedKzGraduationLocality: "",
    kzGraduationCertificateSeries: "",
    kzGraduationCertificateNumber: "",
    graduationQualification: "",
    kzGraduationCertificateAveragePoint: 0.0,
    selectedDistinctionMarkType: "",
    selectedEducationalInstitution: "",
    nostrificationCertificateNumber: "",
    nostrificationCertificateDate: "",
    kazakhLangAssessment: "",
    russianLangAssessment: "",
    englishCertificatePoints: "",
    // Файлы
    graduationCertificateIssueDate: "", // Дата выдачи сертификата об образовании
    qualificationCommissionDecisionDate: "",
    graduationCertificate: "",
    copyGraduationCertificate: "",
    graduationCertificateApplication: "",
    graduationCertificateFileName: "", // Имя основного документа
    graduationCertificateApplicationFileName: "", // Имя документа с приложением
    graduationCertificateName: "", // Чисто для иностранцев
    specialityName: "",
    selectedEducationInstitutionType: "", // ID выбранного education institution type

    //Admission
    selectedExamType: "",
    selectedExamLanguage: "",
    selectedEnglishCertificateType: "",
    selectedOlympiadCertificateType: "",
    selectedAdditionalCourse: "",
    selectedFinancingProgram: "",
    selectedFinancialSource: "",
    selectedQuota: "",
    individualTestingCode: "",
    entDetails: {},
    grantDetails: {},
    paymentAmount: "",
    entCertificateScan: "", // Файл
    englishExamScan: "", // Файл
    olympiadCertificateScan: "",
    grantCertificateScan: "",
    paymentReceiptScan: "",
    examMark: "",
    aetEnglishPoint: 0,
    aetICTPoint: 0,

    //Achievements
    achievementInfo: [],

    // Пути Различных файлов
    entCertificateScanPath: "",
    englishExamScanPath: "",
    olympiadCertificateScanPath: "",
    graduationCertificatePath: "",
    graduationCertificateApplicationPath: "",
    copyGraduationCertificatePath: "",
    identityFrontPath: "",
    identityBackPath: "",
    form086Path: "",
    documentConfirmingAvailabilityOfInternalGrantScanPath: "",
    pripisnoiBiletPath: "",
    grantCertificatePath: "",
    paymentReceiptPath: "",

    combinedExamPointInformatics: "",
    combinedExamPointEnglish: "",
    interviewPoints: "",
    creativeExamPoints: "",
    isApproved: false,
    showApprove: false,

    // Статус абитуриента
    enrolleeStatus: "",
    disableSendMessageButton: false,

    selectedAcademicDegree: "",
    selectedEducationalProgramGroup: "",
    selectedEducationalProgram: "",
    selectedRegionResidence: "",
    selectedRegionLife: "",
    selectedStreet: "",
    selectedLifeAddress: "",
    selectedResidenceAddress: "",
    selectedSchoolAddress: "",
    selectedSchoolRegion: "",
    selectedSchoolStreet: "",
    selectedCustomInstution: "",
    selectedStudyStatus: "",

    barCode: "",
    searchText: "",
    resultText: [],
    residenceResultPlaces: [],
    lifeResultPlaces: [],
    schoolResultPlaces: [],
    resultSchools: [],
    schoolStreets: [],
    resultSchoolStreets: [],
    customInstitution: false,
    abiturInfo: {},
  };

  handleChangeForeignCountry = (event) => {
    const isKazakhstan = Number(event.target.value) === 86;

    this.setState({
      foreignCountry: event.target.value,
      showKazakhstanFields: isKazakhstan
    }, () => {
    });
  }

  handleInputChange = (index, field, value) => {
    this.setState((prevState) => {
      const newAchievementInfo = [...prevState.achievementInfo];
      newAchievementInfo[index][field] = value;
      return { achievementInfo: newAchievementInfo };
    });
  };

  fetchData = () => {
    const { secretary, admissionInfo, dictionary, educationInfo } = this.props.services;
    const Id = this.props.id;
    secretary.getAbiturBarCode(Id).then((response) => {
      this.setState({ barCode: response.data });
    });
    secretary.getEnrolleeStatus(Id).then((response) => {
      this.setState({ enrolleeStatus: response.data });
    });
    secretary.checkConfirm(Id).then((response) => {
      this.setState({ isApproved: response.data });
    });
    // secretary.getEnrolleeById(Id).then((response) => {
    //   this.setState(
    //     {
    //       user: response.data.user,
    //       admission: response.data,
    //       // Текстовые поля с баллами
    //       combinedExamPointEnglish: response.data.combinedExamPointEnglish,
    //       combinedExamPointInformatics:
    //         response.data.combinedExamPointInformatics,
    //       interviewPoints: response.data.interviewPoints,
    //       creativeExamPoints: response.data.creativeExamPoints,
    //     },
    //     () => {
    //       this.setState({
    //         selectedAcademicDegree: this.state.admission.academicDegree?.id,
    //         selectedEducationalProgramGroup:
    //           this.state.admission.educationalProgram?.educationalProgramGroup
    //             ?.id,
    //         selectedEducationalProgram:
    //           this.state.admission.educationalProgram?.id,
    //       });
    //     }
    //   );
    // });

    //GET методы для получения данных для списков
    dictionary.getIssuingAuthority().then((response) => {
      if (response?.data) {
        this.setState({
          institutions: response.data,
        });
      }
    });

    dictionary.getDocumentTypes().then((response) => {
      if (response?.data) {
        this.setState({
          documents: response.data,
        });
      }
    });

    educationInfo.getCountries().then((response) => {
      this.setState({ countries: response.data });
    });
    // educationInfo.getLocalityTypes().then((response) => {
    //   this.setState({ localityTypes: response.data });
    // });
    // educationInfo.getLocalities().then((response) => {
    //   this.setState({ localities: response.data });
    // });
    educationInfo.getDistinctionMarkTypes().then((response) => {
      this.setState({ distinctionMarkTypes: response.data });
    });
    educationInfo.getAllKatoRegions().then((response) => {
      this.setState({ regions: response.data });
    });
    educationInfo.getEducationInstitutionTypes().then((response) => {
      this.setState({ educationInstitutionTypes: response.data });
    });
    admissionInfo.getAcademicDegrees().then((response) => {
      this.setState({ academicDegrees: response.data });
    });
    admissionInfo.getExamTypes().then((response) => {
      this.setState({ examTypes: response.data });
    });
    admissionInfo.getExamLanguages().then((response) => {
      this.setState({ examLanguages: response.data });
    });
    admissionInfo.getExamLanguages().then((response) => {
      this.setState({ languages: response.data });
    });
    admissionInfo.getEnglishCertificateTypes().then((response) => {
      this.setState({ englishCertificateTypes: response.data });
    });
    admissionInfo.getOlympiadCertificateTypes().then((response) => {
      this.setState({ olympiadCertificateTypes: response.data });
    });
    admissionInfo.getAdditionalCourses().then((response) => {
      this.setState({ additionalCourses: response.data })
    });
    admissionInfo.getFinancingPrograms().then((response) => {
      this.setState({ financingPrograms: response.data })
    });
    admissionInfo.getQuota().then((response) => {
      this.setState({ quotas: response.data });
    });
    secretary.getSocialStatusTypes().then((response) => {
      this.setState({ socialStatusTypes: response.data });
    });
    admissionInfo.getEducationalProgramGroups().then((response) => {
      this.setState({
        educationalProgramGroups: response.data,
      });
    });

    secretary.getAbitur(Id).then((r) => {
      if (r.data) {

        this.setState({
          name: r.data.name,
          surname: r.data.surname,
          patronymic: r.data.patronymic,
          nameInLatin: r.data.nameInLatin,
          surnameInLatin: r.data.surnameInLatin,
          phoneNumber: r.data.phoneNumber,
          nationality: r.data.nationality?.id,
          email: r.data.email,
          citizenship: r.data.citizenship?.id,
          foreignCountry: r.data.foreignCountry?.id,
          showKazakhstanFields: Number(r.data.foreignCountry?.id) === 86 ? true : false,
          isMale: r.data.isMale,
          graduationPlaceCity: r.data.graduationPlaceCity,
          needDorm: r.data.needDorm,
          isMarried: r.data.isMarried,
          isLocal: r.data.isLocal,
          iin: r.data.iin,
          residenceAddress: r.data.residenceAddress,
          selectedResidenceAddress: r.data.residenceAddressId?.id,
          selectedRegionResidence:
            r.data.residenceAddressId?.centerKatoRegion?.codePrefix,
          lifeAddress: r.data.lifeAddress,
          factAddress: r.data.factAddress,
          ruralQuote: r.data.ruralQuote,
          selectedLifeAddress: r.data.lifeAddressId?.id,
          selectedRegionLife:
            r.data.lifeAddressId?.centerKatoRegion?.codePrefix,
          locality: r.data.locality?.id,
          firstParentName: r.data.firstParentName,
          firstParentSurname: r.data.firstParentSurname,
          firstParentPhoneNumber: r.data.firstParentPhoneNumber,
          firstParentPatronymic: r.data.firstParentPatronymic,
          dateOfBirth: r.data.dateOfBirth,
          secondParentName: r.data.secondParentName,
          secondParentSurname: r.data.secondParentSurname,
          secondParentPatronymic: r.data.secondParentPatronymic,
          secondParentPhoneNumber: r.data.secondParentPhoneNumber,
          imageID: r.data.image3x4?.id,
          imagePath: r.data.image3x4?.path,
          socialStatus: r.data.socialStatus?.id,
          socialStatusFileId: r.data.socialStatusFile?.id,
          socialStatusPath: r.data.socialStatusFile?.path,
          englishCertificatePoints: r.data.englishCertificatePoints,

          selectedIssuingAuthority: r.data.documentIssuingAuthority?.id,
          selectedIdentityDocumentType: r.data.identityDocumentType?.id,
          selectedIdentityDocumentNumber: r.data.identityDocumentNumber,
          selectedIdentityDocumentIssueDate: r.data.identityDocumentIssueDate,
          selectedIdentityDocumentValidityPeriod:
            r.data.identityDocumentValidityPeriod,
          selectedOtherDocumentType: r.data.otherDocumentType,
          identityFront: r.data.identityDocumentScanFront?.id,
          identityBack: r.data.identityDocumentScanBack?.id,
          form086: r.data.form086?.id,
          documentConfirmingAvailabilityOfInternalGrantScan:
            r.data.documentConfirmingAvailabilityOfInternalGrantScan?.id,
          pripisnoiBiletScan: r.data.pripisnoiBilet?.id,
          identityFrontPath: r.data.identityDocumentScanFront?.path,
          identityBackPath: r.data.identityDocumentScanBack?.path,
          form086Path: r.data.form086?.path,
          documentConfirmingAvailabilityOfInternalGrantScanPath:
            r.data.documentConfirmingAvailabilityOfInternalGrantScan?.path,
          pripisnoiBiletPath: r.data.pripisnoiBilet?.path,
          selectedEducationInstitutionType: r.data.educationInstitutionType?.id,
          selectedCountry: r.data.country?.id,

          // Для КЗ
          selectedKzGraduationLocality: r.data.kzGraduationLocality?.id,
          selectedKzGraduationLocalityType:
            r.data.kzGraduationLocality?.localityType.id,
          selectedKzEducationInstitution: r.data.kzEducationalInstitution?.id,
          kzGraduationCertificateSeries: r.data.kzGraduationCertificateSeries,
          kzGraduationCertificateNumber: r.data.kzGraduationCertificateNumber,
          graduationQualification: r.data.graduationQualification,
          kzGraduationCertificateAveragePoint:
            r.data.kzGraduationCertificateAveragePoint,
          selectedDistinctionMarkType: r.data.distinctionMarkType?.id,
          selectedSchoolRegion: r.data.schoolRegionId?.codePrefix,
          selectedSchoolStreet: r.data.schoolStreetId?.id,
          selectedSchoolAddress: r.data.school?.id,
          selectedStudyStatus: r.data.studyType,
          kazakhLangAssessment: r.data.kazakhLangAssessment,
          russianLangAssessment: r.data.russianLangAssessment,

          // Для иностранцев
          selectedEducationalInstitution: r.data.educationalInstitution,
          graduationCertificateIssueDate: r.data.graduationCertificateIssueDate,
          qualificationCommissionDecisionDate: r.data.qualificationCommissionDecisionDate,
          graduationCertificateName: r.data.graduationCertificateName,

          nostrificationCertificateNumber:
            r.data.nostrificationCertificateNumber, // Строка
          nostrificationCertificateDate: r.data.nostrificationCertificateDate, // Дата
          graduationCertificate: r.data.graduationCertificate?.id, // Объект
          graduationCertificateApplication:
            r.data.graduationCertificateApplication?.id, // Объект
          copyGraduationCertificate: r.data.copyGraduationCertificate?.id,
          specialityName: r.data.specialityName, // Строка
          paymentAmount: r.data.paymentAmount,
          grantDetails: {
            grantNumber: r.data.grantNumber,
            grantIssueDate: r.data.grantIssueDate,
          },

          // Path (путь) загружаемых документов (graduationCertificate и graduationCertificateApplication)
          graduationCertificatePath: r.data.graduationCertificate?.path,
          graduationCertificateApplicationPath:
            r.data.graduationCertificateApplication?.path,
          copyGraduationCertificatePath: r.data.copyGraduationCertificate?.path,
          selectedAcademicDegree: r.data.academicDegree?.id,
          selectedEducationalProgramGroup:
            r.data.educationalProgram?.educationalProgramGroup,
          selectedEducationalProgram: r.data.educationalProgram?.duId,
          selectedExamType: r.data.examType?.id,
          selectedExamLanguage: r.data.examLanguage?.id,
          selectedLanguage: r.data.language?.id,
          selectedEnglishCertificateType: r.data.englishCertificateType?.id,
          selectedOlympiadCertificateType: r.data.olympiadCertificateType?.id,
          selectedAdditionalCourse: r.data.additionalCourse?.id,
          selectedFinancingProgram: r.data.financingProgram?.id,
          selectedFinancialSource: r.data.financingSource?.id,
          selectedQuota: r.data.quota?.id,
          entCertificateScanPath: r.data.entCertificate?.path,
          englishExamScanPath: r.data.englishCertificate?.path,
          olympiadCertificateScanPath: r.data.olympiadCertificate?.path,
          grantCertificatePath: r.data.grantCertificate?.path,
          paymentReceiptPath: r.data.paymentReceipt?.path,

          individualTestingCode: r.data.ikt,
          entDetails: r.data.entDetailsDtoResponse,
          creativeExamPoints: r.data.creativeExamPoints,
          entCertificateScan: r.data.entCertificate?.id,
          olympiadCertificateScan: r.data.olympiadCertificate?.id,
          englishExamScan: r.data.englishCertificate?.id,
          grantCertificateScan: r.data.grantCertificate?.id,
          paymentReceiptScan: r.data.paymentReceipt?.id,
          aetEnglishPoint: r.data.aetEnglishPoint,
          aetIctPoint: r.data.aetICTPoint,
          examMark: r.data.examMark,

          achievementInfo: r.data.achievementInfo,

          // Path (путь) загружаемых документов (entCertificateScan и englishExamScan)

          resultText: this.state.countries,
          abiturInfo: r.data,
        });

        r.data.residenceAddressId?.centerKatoRegion?.codePrefix &&
          educationInfo
            .getAllKatoPlacesByRegion(
              r.data.residenceAddressId?.centerKatoRegion?.codePrefix
            )
            .then((response) => {
              this.setState({ residencePlaces: response.data });
              this.setState({ residenceResultPlaces: response.data });
            });
        r.data.lifeAddressId?.centerKatoRegion?.codePrefix &&
          educationInfo
            .getAllKatoPlacesByRegion(
              r.data.lifeAddressId?.centerKatoRegion?.codePrefix
            )
            .then((response) => {
              this.setState({ lifePlaces: response.data });
              this.setState({ lifeResultPlaces: response.data });
            });
        r.data.schoolRegionId?.codePrefix &&
          educationInfo
            .getAllKatoPlacesByRegion(r.data.schoolRegionId?.codePrefix)
            .then((response) => {
              this.setState({ schoolPlaces: response.data });
              this.setState({ schoolResultPlaces: response.data });
            });

        r.data.schoolStreetId?.id &&
          educationInfo
            .getSchoolsByKatoId(r.data.schoolStreetId?.id)
            .then((response) => {
              this.setState({ schools: response.data });
              this.setState({ resultSchools: response.data });
            });

        admissionInfo
          .getDuEducationalPrograms(this.state.selectedAcademicDegree)
          .then((response) => {
            this.setState({
              educationalPrograms: response.data,
            });
          });

        admissionInfo
          .getFinancingSources(this.state.selectedStudyStatus)
          .then((response) => {
            this.setState({
              financialSources: response.data,
            });
          });
      }

      if (this.state.selectedEducationalInstitution) {
        this.setState({
          customInstitution: true,
        });
      }
    });
  };

  componentDidMount() {
    this.fetchData();
  }

  sendMessageToEmail = (event) => {
    this.setState({ disableSendMessageButton: true });

    const { secretary } = this.props.services;
    event.preventDefault();
    const newObject = {
      email: this.state.user.email,
      message: this.state.emailMessage,
    };
    secretary
      .sendMessage(newObject)
      .then((r) => {
        // console.log(r);
        if (r.status === 200) {
          alert("Сообщение было успешно отправлено");
        } else {
          alert("Произошла ошибка");
        }
      })
      .finally(() => this.setState({ disableSendMessageButton: false }));
  };
  sendPoints = (event) => {
    const Id = this.props.id;
    event.preventDefault();
    const { secretary } = this.props.services;
    const newObject = {
      combinedExamPointInformatics: this.state.combinedExamPointInformatics,
      combinedExamPointEnglish: this.state.combinedExamPointEnglish,
      interviewPoints: this.state.interviewPoints,
      creativeExamPoints: this.state.creativeExamPoints,
      userId: Id,
    };
    secretary
      .uploadPoints(newObject)
      .then((r) => {
        // console.log(r);
        alert("Сообщение было успешно отправлено");
        // this.state.combinedExamPointEnglish = ""
        // this.setState({ combinedExamPointEnglish: "" })
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  isApproved = () => {
    const Id = this.props.id;
    this.props.services.secretary.isApproved(Id).then((r) => {
      this.setState({ isApproved: false });
      alert("Пользователь успешно подтвержден");
      console.log(r);
    });
  };

  handleFirstParentPhoneNumberChange = (firstParentPhoneNumber) => {
    this.setState({ firstParentPhoneNumber });
  };

  handleSecondParentPhoneNumberChange = (secondParentPhoneNumber) => {
    this.setState({ secondParentPhoneNumber });
  };

  handlePhoneChange = (phoneNumber) => {
    this.setState({ phoneNumber });
  };

  giveStatusToEnrollee = () => {
    this.props.services.secretary
      .giveStatusToEnrollee({
        userId: this.props.id,
        status: this.state.enrolleeStatus,
      })
      .then(() => {
        this.setState({ showApprove: true });
        alert("Статус данного абитурента был успешно задан");
      });
  };

  updateEducationalProgram = () => {
    if (window.confirm("Вы действительно хотите сменить ГОП/ОП?")) {
      this.props.services.secretary
        .updateEducationalProgram(
          this.state.selectedEducationalProgram,
          this.props.id
        )
        .then((r) => {
          if (r.status === 200) {
            alert("Образовательная программа студента была успешно изменена");
            this.setState({ barCode: r.data });
          } else {
            alert("Произошла ошибка");
          }
        });
    }
  };

  filter = (e) => {
    const keyword = e.target.value;

    if (keyword !== "") {
      const results = this.state.countries.filter((country) => {
        return country.name.toLowerCase().startsWith(keyword.toLowerCase());
      });
      this.setState({ resultText: results });
    } else {
      this.setState({ resultText: this.state.countries });
    }

    this.setState({ searchText: keyword });
  };

  filterPlaces = (e, type) => {
    const keyword = e.target.value;

    if (type === "residence") {
      if (keyword !== "") {
        const results = this.state.residencePlaces.filter((place) => {
          return place.nameru.toLowerCase().includes(keyword.toLowerCase());
        });
        this.setState({ residenceResultPlaces: results });
      } else {
        this.setState({ residenceResultPlaces: this.state.residencePlaces });
      }
    }

    if (type === "life") {
      if (keyword !== "") {
        const results = this.state.lifePlaces.filter((place) => {
          return place.nameru.toLowerCase().includes(keyword.toLowerCase());
        });
        this.setState({ lifeResultPlaces: results });
      } else {
        this.setState({ lifeResultPlaces: this.state.lifePlaces });
      }
    }

    if (type === "school") {
      if (keyword !== "") {
        const results = this.state.schoolPlaces.filter((place) => {
          return place.nameru.toLowerCase().includes(keyword.toLowerCase());
        });
        this.setState({ schoolResultPlaces: results });
      } else {
        this.setState({ schoolResultPlaces: this.state.schoolPlaces });
      }
    }

    this.setState({ searchText: keyword });
  };

  filterSchools = (e) => {
    const keyword = e.target.value;

    if (keyword !== "") {
      const results = this.state.schools.filter((schools) => {
        return schools.name.toLowerCase().includes(keyword.toLowerCase());
      });
      this.setState({ resultSchools: results });
    } else {
      this.setState({ resultSchools: this.state.schools });
    }

    this.setState({ searchText: keyword });
  };

  DownloadFile = (userId, id, path) => {
    this.props.services.fileUpload.getDocumentSecretary(
      userId,
      id,
      path?.split("/").pop()
    );
  };

  getAllKatoPlacesByRegion = (id, type) => {
    if (type === "residence") {
      this.props.services.educationInfo
        .getAllKatoPlacesByRegion(id)
        .then((response) => {
          this.setState({ residencePlaces: response.data });
          this.setState({ residenceResultPlaces: response.data });
        });
    }
    if (type === "life") {
      this.props.services.educationInfo
        .getAllKatoPlacesByRegion(id)
        .then((response) => {
          this.setState({ lifePlaces: response.data });
          this.setState({ lifeResultPlaces: response.data });
        });
    }
    if (type === "school") {
      this.props.services.educationInfo
        .getAllKatoPlacesByRegion(id)
        .then((response) => {
          this.setState({ schoolPlaces: response.data });
          this.setState({ schoolResultPlaces: response.data });
        });
    }
  };

  isCertificateValid = (certificateType, points) => {
    switch (certificateType) {
      case 1: // IELTS
        return points >= 6.5;
      case 2: // TOEFL IBT
        return points >= 79;
      case 3: // TOEFL PBT
        return points >= 548;
      default:
        return false;
    }
  };

  getAllKatoSchools = (id) => {
    this.props.services.educationInfo
      .getSchoolsByKatoId(id)
      .then((response) => {
        this.setState({ schools: response.data });
        this.setState({ resultSchools: response.data });
      });
  };

  nationalities = [
    {
      value: "271",
      label: "казах",
    },
    {
      value: "324",
      label: "киргиз",
    },
    {
      value: "341",
      label: "кореец",
    },
    {
      value: "367",
      label: "курд",
    },
    {
      value: "468",
      label: "молдаванин",
    },
    {
      value: "476",
      label: "мордовец",
    },
    {
      value: "571",
      label: "поляк",
    },
    {
      value: "591",
      label: "русские",
    },
    {
      value: "647",
      label: "таджик",
    },
    {
      value: "658",
      label: "татарин",
    },
    {
      value: "728",
      label: "турок",
    },
    {
      value: "755",
      label: "узбек",
    },
    {
      value: "756",
      label: "уйгур",
    },
    {
      value: "759",
      label: "украинец",
    },
    {
      value: "852",
      label: "чеченец",
    },
    {
      value: "857",
      label: "чуваш",
    },
    {
      value: "23",
      label: "азербайджанец",
    },
    {
      value: "97",
      label: "башкир",
    },
    {
      value: "104",
      label: "белорус",
    },
    {
      value: "165",
      label: "грек",
    },
    {
      value: "203",
      label: "дунганин",
    },
    {
      value: "209",
      label: "еврей",
    },
    {
      value: "247",
      label: "ингуш",
    },
    {
      value: "57",
      label: "армянин",
    },
    {
      value: "499",
      label: "немец",
    },
    {
      value: "925",
      label: "пакистанец",
    },
    {
      value: "1000",
      label: "другое",
    },
  ];

  checkProperties = (obj) => {
    for (const key in obj) {
      if (obj[key] !== null && obj[key] !== "") {
        return true;
      }

      return false;
    }
  };

  handleSelectedAcademicDegree = (id) => {
    const { admissionInfo } = this.props.services;
    this.setState({
      selectedAcademicDegree: id,
    });
    admissionInfo.getDuEducationalPrograms(id).then((response) => {
      this.setState({
        educationalPrograms: response.data,
      });
    });
  };

  handleSelectedStudyStatus = (id) => {
    const { admissionInfo } = this.props.services;
    this.setState({
      selectedStudyStatus: id,
    });
    admissionInfo.getFinancingSources(id).then((response) => {
      this.setState({
        financialSources: response.data,
      });
    });
  };

  handleSelectEducationalProgram = (selectedEducationalProgram) => {
    const { admissionInfo } = this.props.services;

    if (
      this.state.selectedEducationalProgram !== null &&
      this.state.selectedEducationalProgram !== undefined &&
      this.state.selectedEducationalProgram !== ""
    ) {
      admissionInfo
        .getEducationalProgramGroupByDuId(selectedEducationalProgram)
        .then((response) => {
          this.setState({
            selectedEducationalProgramGroup: response.data,
          });
        });
    }
  };

  handleSubmit = () => {
    const { state } = this;
    const Id = this.props.id;
    if (state.iin?.length < 1) {
      myRefIin.current.reportValidity();
    } else if (!state.firstParentName) {
      myRefName.current.reportValidity();
    } else if (!state.firstParentSurname) {
      myRefSurname.current.reportValidity();
    } else if (state.iin?.length !== 12) {
      alert("введите правильный иин");
    } else {
      const data = {
        name: state.name || null,
        nameInLatin: state.nameInLatin || null,
        surname: state.surname || null,
        surnameInLatin: state.surnameInLatin || null,
        patronymic: state.patronymic || null,
        phoneNumber: state.phoneNumber || null,
        nationality: state.nationality || null,
        iin: state.iin || null,
        citizenship: state.citizenship || null,
        foreignCountry: state.foreignCountry || null,
        isMale: state.isMale || null,
        graduationPlaceCity: state.graduationPlaceCity || null,
        needDorm: state.needDorm || null,
        isMarried: state.isMarried || null,
        isLocal: state.isLocal || null,
        englishCertificatePoints: state.englishCertificatePoints || null,
        residenceAddress: state.residenceAddress || null,
        residenceAddressId: state.selectedResidenceAddress || null,
        lifeAddress: state.lifeAddress || null,
        lifeAddressId: state.selectedLifeAddress || null,
        factAddress: state.factAddress || null,
        ruralQuote: state.ruralQuote || false,
        firstParentName: state.firstParentName || null,
        firstParentSurname: state.firstParentSurname || null,
        firstParentPhoneNumber: state.firstParentPhoneNumber || null,
        firstParentPatronymic: state.firstParentPatronymic || null,
        dateOfBirth: state.dateOfBirth || null,
        secondParentName: state.secondParentName || null,
        secondParentSurname: state.secondParentSurname || null,
        secondParentPatronymic: state.secondParentPatronymic || null,
        secondParentPhoneNumber: state.secondParentPhoneNumber || null,
        socialStatus: state.socialStatus || null,
        socialStatusFileId: state.socialStatusFileId || null,
        socialStatusPath: state.socialStatusPath || null,
        image3x4Id: state.imageID || null,
        documentIssuingAuthorityId: state.selectedIssuingAuthority || null,
        identityDocumentTypeId: state.selectedIdentityDocumentType || null,
        identityDocumentNumber: state.selectedIdentityDocumentNumber || null,
        identityDocumentIssueDate:
          state.selectedIdentityDocumentIssueDate || null,
        identityDocumentValidityPeriod:
          state.selectedIdentityDocumentValidityPeriod || null,
        otherDocumentType: state.selectedOtherDocumentType || null,
        identityDocumentScanFrontId: state.identityFront || null,
        identityDocumentScanBackId: state.identityBack || null,
        form086Id: state.form086 || null,
        documentConfirmingAvailabilityOfInternalGrantScanId:
          state.documentConfirmingAvailabilityOfInternalGrantScan || null,
        pripisnoiBiletId: state.pripisnoiBiletScan || null,
        country: state.selectedCountry || null,
        kzGraduationLocality: state.selectedKzGraduationLocality || null, // Если человек выбрал Казахстан
        educationalInstitution: state.customInstitution
          ? state.selectedEducationalInstitution
          : state.selectedEducationInstitutionType !== 1
            ? state.selectedEducationalInstitution
            : "",
        distinctionMarkType: state.selectedDistinctionMarkType || null, // Если человек выбрал Казахстан + Выбрал университет
        kzGraduationCertificateSeries:
          state.kzGraduationCertificateSeries || null, // Если человек выбрал Казахстан
        kzGraduationCertificateNumber:
          state.kzGraduationCertificateNumber || null, // Если человек выбрал Казахстан
        graduationQualification: state.graduationQualification || null,
        kzGraduationCertificateAveragePoint:
          state.kzGraduationCertificateAveragePoint || null, // Если человек выбрал Казахстан
        graduationCertificateName: state.graduationCertificateName || null,
        russianLangAssessment: state.russianLangAssessment || null,
        kazakhLangAssessment: state.kazakhLangAssessment || null,
        graduationCertificateIssueDate:
          state.graduationCertificateIssueDate || null, // Дата выдачи документа об образовании
        qualificationCommissionDecisionDate: state.qualificationCommissionDecisionDate || null,
        nostrificationCertificateNumber:
          state.nostrificationCertificateNumber || null, // Только для иностранных студеньов (школа)
        nostrificationCertificateDate:
          state.nostrificationCertificateDate || null, // Только для иностранных студеньов (школа)
        graduationCertificate: state.graduationCertificate || null,
        graduationCertificateApplication:
          state.graduationCertificateApplication || null,
        copyGraduationCertificate: state.copyGraduationCertificate || null,
        specialityName: state.specialityName || null, // Наименование специальности (для колледжа и вузов)
        educationInstitutionType:
          state.selectedEducationInstitutionType || null, // Тип образовательного учреждения
        academicDegree: state.selectedAcademicDegree || null,
        educationalProgram: state.selectedEducationalProgram || null,
        examType: state.selectedExamType || null,
        examLanguage: state.selectedExamLanguage || null,
        language: state.selectedLanguage || null,
        aetEnglishPoint: state.aetEnglishPoint || null,
        aetIctPoint: state.aetICTPoint || null,
        examMark: state.examMark || null,
        englishCertificateType: state.selectedEnglishCertificateType || null,
        olympiadCertificateType: state.selectedOlympiadCertificateType || null,
        additionalCourseId: state.selectedAdditionalCourse || null,
        financingProgramId: state.selectedFinancingProgram || null,
        financingSourceId: state.selectedFinancialSource || null,
        quotaId: state.selectedQuota || null,
        englishCertificateId: state.englishExamScan || null,
        olympiadCertificateId: state.olympiadCertificateScan || null,
        entCertificateId: state.entCertificateScan || null,
        ikt: state.individualTestingCode || null,
        ...(this.checkProperties(state.entDetails) && {
          entDetails: {
            mathematicalLiteracyPoint:
              state.entDetails?.mathematicalLiteracyPoint || null,
            readingLiteracyPoint:
              state.entDetails?.readingLiteracyPoint || null,
            kazakhstanHistoryPoint:
              state.entDetails?.kazakhstanHistoryPoint || null,
            profileSubject1Point:
              state.entDetails?.profileSubject1Point || null,
            profileSubject2Point:
              state.entDetails?.profileSubject2Point || null,
          },
        }),
        creativeExamPoints: state.creativeExamPoints,
        studyType: state.selectedStudyStatus,
        ...(state.selectedStudyStatus === 1 && {
          paymentReceiptId: state.paymentReceiptScan || null,
          paymentAmount: state.paymentAmount || null,
        }),
        ...(state.selectedStudyStatus === 2 && {
          grantCertificate: state.grantCertificateScan || null,
          grantIssueDate: state.grantDetails?.grantIssueDate || null,
          grantNumber: state.grantDetails?.grantNumber || null,
        }),
        school: state.schools.length ? state.selectedSchoolAddress : null,
        schoolRegionId: state.selectedSchoolRegion || null,
        schoolStreetId: state.selectedSchoolStreet || null,
        achievementInfo: state.achievementInfo || null,
      };

      const { secretary } = this.props.services;

      secretary
        .postAbitur(Id, data)
        .then(() => {
          alert("Ваши данные были успешно обновлены");

          this.componentDidMount();
        })
        .catch(() => {
          this.setState({
            errorMessage:
              "При сохранении ваших данных произошла какая-то ошибка",
          });
        });
    }
  };

  render() {
    const { selectedAcademicDegree, englishCertificatePoints, selectedEnglishCertificateType } = this.state;
    const { barCode } = this.state;
    const schoolGraduate = (
      <>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Страна, в котором закончил(-а) учебное заведение
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                select
                children
                fullWidth
                SelectProps={{
                  MenuProps: { autoFocus: false },
                }}
                onChange={(event) =>
                  this.setState({
                    selectedCountry: event.target.value,
                  })
                }
                onClose={() =>
                  this.setState({
                    searchText: "",
                  })
                }
                disabled={this.state.isEditable}
                value={this.state.selectedCountry}
              >
                <ListSubheader>
                  <TextField
                    size="small"
                    autoFocus
                    placeholder="Введите для поиска или выберите в меню"
                    fullWidth
                    onChange={(e) => this.filter(e)}
                    onKeyDown={(e) => {
                      if (e.key !== "Escape") {
                        e.stopPropagation();
                      }
                    }}
                    inputProps={{
                      style: { backgroundColor: "white" },
                    }}
                  />
                </ListSubheader>

                {this.state.resultText.map((country) => (
                  <MenuItem key={country.id} value={country.id}>
                    {country.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
        {this.state.selectedCountry &&
          this.state.selectedCountry !==
          this.state.countries.find((country) =>
            country.name.includes("Казахстан")
          ).id && (
            <>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Название образовательного учреждения
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      onChange={(event) =>
                        this.setState({
                          selectedEducationalInstitution: event.target.value,
                        })
                      }
                      value={this.state.selectedEducationalInstitution}
                      disabled={this.state.isEditable}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Наименование и номер документа об образовании
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      onChange={(event) =>
                        this.setState({
                          graduationCertificateName: event.target.value,
                        })
                      }
                      value={this.state.graduationCertificateName}
                      disabled={this.state.isEditable}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Дата выдачи документа об образовании
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      type="date"
                      onChange={(event) =>
                        this.setState({
                          graduationCertificateIssueDate: event.target.value,
                        })
                      }
                      value={this.state.graduationCertificateIssueDate}
                      disabled={this.state.isEditable}
                    ></TextField>
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Диплом (скан)
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <FileUpload
                      helperText="Диплом (скан)"
                      fileType={Constants.FILE_TYPES.graduationCertificate}
                      file={this.state.graduationCertificate}
                      filePath={this.state.graduationCertificatePath}
                      userId={this.props.id}
                      handleSetFileId={(fileId) =>
                        this.setState({ graduationCertificate: fileId })
                      }
                      handleDelete={() => {
                        this.fetchData();
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Приложение к диплому(скан)
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <FileUpload
                      helperText="Приложение к диплому (скан)"
                      fileType={
                        Constants.FILE_TYPES.graduationCertificateApplication
                      }
                      file={this.state.graduationCertificateApplication}
                      filePath={this.state.graduationCertificateApplicationPath}
                      userId={this.props.id}
                      handleSetFileId={(fileId) =>
                        this.setState({
                          graduationCertificateApplication: fileId,
                        })
                      }
                      handleDelete={() => {
                        this.fetchData();
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      № свидетельства о нострификации
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      onChange={(event) =>
                        this.setState({
                          nostrificationCertificateNumber: event.target.value,
                        })
                      }
                      value={this.state.nostrificationCertificateNumber}
                      disabled={this.state.isEditable}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Дата свидетельства о нострификации
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      type="date"
                      onChange={(event) =>
                        this.setState({
                          nostrificationCertificateDate: event.target.value,
                        })
                      }
                      value={this.state.nostrificationCertificateDate}
                      disabled={this.state.isEditable}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
            </>
          )}
        {this.state.selectedCountry &&
          this.state.selectedCountry ===
          this.state.countries.find((country) =>
            country.name.includes("Казахстан")
          ).id && (
            <>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Регион образовательного учреждения
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      select
                      children
                      disabled={this.state.isEditable}
                      defaultValue=""
                      value={this.state.selectedSchoolRegion}
                      onChange={(e) => {
                        this.setState({
                          selectedSchoolRegion: e.target.value,
                        });
                        this.getAllKatoPlacesByRegion(e.target.value, "school");
                      }}
                    >
                      <MenuItem value="none" disabled>
                        Выберите один из вариантов
                      </MenuItem>

                      {this.state.regions.map((region) => (
                        <MenuItem key={region.id} value={region.codePrefix}>
                          {region.nameru}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Район образовательного учреждения
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      select
                      children
                      SelectProps={{
                        MenuProps: { autoFocus: false },
                      }}
                      defaultValue=""
                      disabled={this.state.isEditable}
                      value={this.state.selectedSchoolStreet}
                      onChange={(e) => {
                        this.setState({
                          selectedSchoolStreet: e.target.value,
                        });
                        this.getAllKatoSchools(e.target.value);
                      }}
                      onClose={() =>
                        this.setState({
                          searchText: "",
                        })
                      }
                    >
                      <ListSubheader>
                        <TextField
                          size="small"
                          autoFocus
                          placeholder="Введите для поиска или выберите в меню"
                          fullWidth
                          onChange={(e) => this.filterPlaces(e, "school")}
                          onKeyDown={(e) => {
                            if (e.key !== "Escape") {
                              e.stopPropagation();
                            }
                          }}
                          inputProps={{
                            style: { backgroundColor: "white" },
                          }}
                        />
                      </ListSubheader>
                      {this.state.schoolResultPlaces.map((place) => (
                        <MenuItem key={place.id} value={place.id}>
                          {place.nameru}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Tooltip
                  title="Нажмите эту кнопку если не нашли вашу школу, и введите название снизу"
                  arrow
                  enterDelay={1000}
                >
                  {this.state.isEditable ? (
                    <></>
                  ) : (
                    <Button
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        this.setState({
                          customInstitution: !this.state.customInstitution,
                        });
                      }}
                    >
                      {this.state.customInstitution
                        ? "Выбрать из списка"
                        : "Не нашли школу?"}
                    </Button>
                  )}
                </Tooltip>
              </Grid>
              <br />
              {this.state.customInstitution ? (
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Название образовательного учреждения
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        onChange={(event) =>
                          this.setState({
                            selectedEducationalInstitution: event.target.value,
                          })
                        }
                        value={this.state.selectedEducationalInstitution}
                        disabled={this.state.isEditable}
                      />
                    </Grid>
                  </Grid>
                </Grid>
              ) : (
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Образовательное учреждение
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        select={true}
                        SelectProps={{
                          MenuProps: { autoFocus: false },
                        }}
                        children
                        defaultValue=""
                        fullWidth
                        onChange={(event) => {
                          this.setState({
                            selectedSchoolAddress: event.target.value,
                          });
                        }}
                        value={this.state.selectedSchoolAddress}
                        disabled={this.state.isEditable}
                        onClose={() =>
                          this.setState({
                            searchText: "",
                          })
                        }
                      >
                        <ListSubheader>
                          <TextField
                            size="small"
                            autoFocus
                            placeholder="Введите для поиска или выберите в меню"
                            fullWidth
                            onChange={(e) => this.filterSchools(e)}
                            onKeyDown={(e) => {
                              if (e.key !== "Escape") {
                                e.stopPropagation();
                              }
                            }}
                            inputProps={{
                              style: { backgroundColor: "white" },
                            }}
                          />
                        </ListSubheader>
                        {this.state.resultSchools.map((school) => (
                          <MenuItem key={school.id} value={school.id}>
                            {school.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
              )}

              {/* <br />
            <Grid item md={9}>
              <Grid container spacing={2}>
                <Grid item xs={5} style={{ marginLeft: "10px" }}>
                  <Typography id="input-slider-1" gutterBottom>
                    Место окончания учебного заведения
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    fullWidth
                    select
                    children
                    onChange={(event) =>
                      this.setState({
                        selectedKzGraduationLocalityType: event.target.value,
                      })
                    }

                    value={this.state.selectedKzGraduationLocalityType}
                  >
                    <MenuItem value="none" disabled>
                      Выберите один из вариантов
                    </MenuItem>
                    {this.state.localityTypes.map((localityType) => (
                      <MenuItem key={localityType.id} value={localityType.id}>
                        {localityType.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>
            <br />
            <Grid item md={9}>
              <Grid container spacing={2}>
                <Grid item xs={5} style={{ marginLeft: "10px" }}>
                  <Typography id="input-slider-1" gutterBottom>
                    Населенный пункт или город
                  </Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    variant="outlined"
                    select
                    children
                    fullWidth
                    onChange={(event) =>
                      this.setState({
                        selectedKzGraduationLocality: event.target.value,
                      })
                    }
                    value={this.state.selectedKzGraduationLocality}
                  >
                    <MenuItem value="none" disabled>
                      Выберите один из вариантов
                    </MenuItem>
                    {this.state.localities.map((locality) => (
                      <MenuItem key={locality.id} value={locality.id}>
                        {locality.name}
                      </MenuItem>
                    ))}
                  </TextField>
                </Grid>
              </Grid>
            </Grid>
            <br / */}
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Серия аттестата о среднем образовании
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      onChange={(event) =>
                        this.setState({
                          kzGraduationCertificateSeries: event.target.value,
                        })
                      }
                      value={this.state.kzGraduationCertificateSeries}
                      disabled={this.state.isEditable}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Номер аттестата о среднем образовании
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      onChange={(event) =>
                        this.setState({
                          kzGraduationCertificateNumber: event.target.value,
                        })
                      }
                      value={this.state.kzGraduationCertificateNumber}
                      disabled={this.state.isEditable}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Дата выдачи
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      type="date"
                      value={this.state.graduationCertificateIssueDate}
                      onChange={(event) =>
                        this.setState({
                          graduationCertificateIssueDate: event.target.value,
                        })
                      }
                      disabled={this.state.isEditable}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Средний балл аттестата
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      type="number"
                      value={this.state.kzGraduationCertificateAveragePoint}
                      onChange={(event) =>
                        this.setState({
                          kzGraduationCertificateAveragePoint:
                            event.target.value,
                        })
                      }
                      disabled={this.state.isEditable}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Оценка по русскому языку
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      fullWidth
                      select
                      children
                      value={this.state.russianLangAssessment}
                      onChange={(event) =>
                        this.setState({
                          russianLangAssessment: event.target.value,
                        })
                      }
                      disabled={this.state.isEditable}
                    >
                      <MenuItem value="none" disabled>
                        Выберите один из вариантов
                      </MenuItem>
                      {assessments.map((assesment) => {
                        return (
                          <MenuItem
                            key={assesment.value}
                            value={assesment.value}
                          >
                            {assesment.value}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Оценка по казахскому языку
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      select
                      children
                      defaultValue=""
                      fullWidth
                      onChange={(event) =>
                        this.setState({
                          kazakhLangAssessment: event.target.value,
                        })
                      }
                      value={this.state.kazakhLangAssessment}
                      disabled={this.state.isEditable}
                    >
                      <MenuItem value="none" disabled>
                        Выберите один из вариантов
                      </MenuItem>
                      {assessments.map((assesment) => {
                        return (
                          <MenuItem
                            key={assesment.value}
                            value={assesment.value}
                          >
                            {assesment.value}
                          </MenuItem>
                        );
                      })}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Знаки отличия
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      variant="outlined"
                      select
                      children
                      defaultValue=""
                      fullWidth
                      onChange={(event) =>
                        this.setState({
                          selectedDistinctionMarkType: event.target.value,
                        })
                      }
                      value={this.state.selectedDistinctionMarkType}
                      disabled={this.state.isEditable}
                    >
                      <MenuItem value="none" disabled>
                        Выберите один из вариантов
                      </MenuItem>
                      {this.state.distinctionMarkTypes
                        .filter(
                          (distinctionMarkType) =>
                            distinctionMarkType.institutionType.id ===
                            this.state.selectedEducationInstitutionType
                        )
                        .map((distinctionMarkType) => (
                          <MenuItem
                            key={distinctionMarkType.id}
                            value={distinctionMarkType.id}
                          >
                            {distinctionMarkType.name}
                          </MenuItem>
                        ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Аттестат (скан)
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <FileUpload
                      helperText="Аттестат (скан)"
                      fileType={Constants.FILE_TYPES.graduationCertificate}
                      file={this.state.graduationCertificate}
                      filePath={this.state.graduationCertificatePath}
                      userId={this.props.id}
                      handleSetFileId={(fileId) =>
                        this.setState({ graduationCertificate: fileId })
                      }
                      handleDelete={() => {
                        this.fetchData();
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Аттестат приложение(скан)
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <FileUpload
                      helperText="Приложение к аттестату (скан)"
                      fileType={
                        Constants.FILE_TYPES.graduationCertificateApplication
                      }
                      file={this.state.graduationCertificateApplication}
                      filePath={this.state.graduationCertificateApplicationPath}
                      userId={this.props.id}
                      handleSetFileId={(fileId) =>
                        this.setState({
                          graduationCertificateApplication: fileId,
                        })
                      }
                      handleDelete={() => {
                        this.fetchData();
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Копия аттестата и приложения к аттестату, заверенные
                      нотариусом
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <FileUpload
                      helperText="Копия аттестата и приложения к аттестату, заверенные нотариусом"
                      fileType={Constants.FILE_TYPES.copyGraduationCertificate}
                      file={this.state.copyGraduationCertificate}
                      filePath={this.state.copyGraduationCertificatePath}
                      userId={this.props.id}
                      handleSetFileId={(fileId) =>
                        this.setState({ copyGraduationCertificate: fileId })
                      }
                      handleDelete={() => {
                        this.fetchData();
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
              <br />
            </>
          )}
      </>
    );
    const collegeGraduate = (
      <>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Степень/квалификация
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                fullWidth
                onChange={(event) =>
                  this.setState({
                    graduationQualification: event.target.value,
                  })
                }
                value={this.state.graduationQualification}
                disabled={this.state.isEditable}
              />
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Дата решения квалификационной комиссии
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                fullWidth
                type="date"
                onChange={(event) =>
                  this.setState({
                    qualificationCommissionDecisionDate: event.target.value,
                  })
                }
                value={this.state.qualificationCommissionDecisionDate}
                disabled={this.state.isEditable}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Страна, в котором закончил(-а) учебное заведение
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                select
                children
                defaultValue=""
                SelectProps={{
                  MenuProps: { autoFocus: false },
                }}
                fullWidth
                onChange={(event) =>
                  this.setState({
                    selectedCountry: event.target.value,
                  })
                }
                disabled={this.state.isEditable}
                onClose={() =>
                  this.setState({
                    searchText: "",
                  })
                }
                value={this.state.selectedCountry}
              >
                <ListSubheader>
                  <TextField
                    size="small"
                    autoFocus
                    placeholder="Введите для поиска или выберите в меню"
                    fullWidth
                    onChange={(e) => this.filter(e)}
                    onKeyDown={(e) => {
                      if (e.key !== "Escape") {
                        e.stopPropagation();
                      }
                    }}
                    inputProps={{
                      style: { backgroundColor: "white" },
                    }}
                  />
                </ListSubheader>
                {this.state.resultText.map((country) => (
                  <MenuItem key={country.id} value={country.id}>
                    {country.name}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
        {this.state.selectedCountry &&
          this.state.selectedCountry ===
          this.state.countries.find((country) =>
            country.name.includes("Казахстан")
          ).id && (
            <>
              <br></br>
              <Grid item md={9}>
                <Grid container spacing={2}>
                  <Grid item xs={5} style={{ marginLeft: "10px" }}>
                    <Typography id="input-slider-1" gutterBottom>
                      Регион образовательного учреждения
                    </Typography>
                  </Grid>
                  <Grid item xs={6}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      select
                      children
                      defaultValue=""
                      value={this.state.selectedSchoolRegion}
                      disabled={this.state.isEditable}
                      onChange={(e) => {
                        this.setState({
                          selectedSchoolRegion: e.target.value,
                        });
                        this.getAllKatoPlacesByRegion(e.target.value, "school");
                      }}
                    >
                      <MenuItem value="none" disabled>
                        Выберите один из вариантов
                      </MenuItem>

                      {this.state.regions.map((region) => (
                        <MenuItem key={region.id} value={region.codePrefix}>
                          {region.nameru}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Название образовательного учреждения
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                fullWidth
                onChange={(event) =>
                  this.setState({
                    selectedEducationalInstitution: event.target.value,
                  })
                }
                value={this.state.selectedEducationalInstitution}
                disabled={this.state.isEditable}
              />
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Название специальности / Образовательной группы
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                fullWidth
                onChange={(event) =>
                  this.setState({
                    specialityName: event.target.value,
                  })
                }
                disabled={this.state.isEditable}
                value={this.state.specialityName}
              />
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Серия диплома
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                fullWidth
                onChange={(event) =>
                  this.setState({
                    kzGraduationCertificateSeries: event.target.value,
                  })
                }
                value={this.state.kzGraduationCertificateSeries}
                disabled={this.state.isEditable}
              />
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Номер диплома
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                fullWidth
                onChange={(event) =>
                  this.setState({
                    kzGraduationCertificateNumber: event.target.value,
                  })
                }
                value={this.state.kzGraduationCertificateNumber}
                disabled={this.state.isEditable}
              />
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Дата выдачи диплома
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                fullWidth
                onChange={(event) =>
                  this.setState({
                    graduationCertificateIssueDate: event.target.value,
                  })
                }
                type="date"
                value={this.state.graduationCertificateIssueDate}
                disabled={this.state.isEditable}
              />
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Средний балл диплома
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                fullWidth
                onChange={(event) =>
                  this.setState({
                    kzGraduationCertificateAveragePoint: event.target.value,
                  })
                }
                // type="date"
                type="number"
                value={this.state.kzGraduationCertificateAveragePoint}
                disabled={this.state.isEditable}
              />
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Знаки отличия
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <TextField
                variant="outlined"
                select
                children
                defaultValue=""
                fullWidth
                onChange={(event) =>
                  this.setState({
                    selectedDistinctionMarkType: event.target.value,
                  })
                }
                value={this.state.selectedDistinctionMarkType}
                disabled={this.state.isEditable}
              >
                <MenuItem value="none" disabled>
                  Выберите один из вариантов
                </MenuItem>
                {this.state.distinctionMarkTypes
                  .filter(
                    (distinctionMarkType) =>
                      distinctionMarkType.institutionType.id ===
                      this.state.selectedEducationInstitutionType
                  )
                  .map((distinctionMarkType) => (
                    <MenuItem
                      key={distinctionMarkType.id}
                      value={distinctionMarkType.id}
                    >
                      {distinctionMarkType.name}
                    </MenuItem>
                  ))}
              </TextField>
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Диплом (скан)
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <FileUpload
                helperText="Диплом (скан)"
                fileType={Constants.FILE_TYPES.graduationCertificate}
                file={this.state.graduationCertificate}
                filePath={this.state.graduationCertificatePath}
                userId={this.props.id}
                handleSetFileId={(fileId) =>
                  this.setState({ graduationCertificate: fileId })
                }
                handleDelete={() => {
                  this.fetchData();
                }}
              />
              {/* {abiturInformation?.graduationCertificate && (
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={() =>
                    this.DownloadFile(
                      documentInformation?.graduationCertificate?.id,
                      documentInformation?.graduationCertificate?.path
                    )
                  }
                >
                  Скачать
                </Button>
              )} */}
            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Диплом приложение (скан)
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <FileUpload
                helperText="Приложение к диплому (скан)"
                fileType={Constants.FILE_TYPES.graduationCertificateApplication}
                file={this.state.graduationCertificateApplication}
                filePath={this.state.graduationCertificateApplicationPath}
                userId={this.props.id}
                handleSetFileId={(fileId) =>
                  this.setState({ graduationCertificateApplication: fileId })
                }
                handleDelete={() => {
                  this.fetchData();
                }}
              />

            </Grid>
          </Grid>
        </Grid>
        <br />
        <Grid item md={9}>
          <Grid container spacing={2}>
            <Grid item xs={5} style={{ marginLeft: "10px" }}>
              <Typography id="input-slider-1" gutterBottom>
                Копия диплома и приложения к диплому, заверенная нотариусом
              </Typography>
            </Grid>
            <Grid item xs={6}>
              <FileUpload
                helperText="Копия диплома и приложения к диплому, заверенная нотариусом"
                fileType={Constants.FILE_TYPES.copyGraduationCertificate}
                file={this.state.copyGraduationCertificate}
                filePath={this.state.copyGraduationCertificatePath}
                userId={this.props.id}
                handleSetFileId={(fileId) =>
                  this.setState({ copyGraduationCertificate: fileId })
                }
                handleDelete={() => {
                  this.fetchData();
                }}
              />
            </Grid>
          </Grid>
        </Grid>
        <br />
      </>
    );
    return (
      <>
        <Grid container spacing={2} justify="center" alignItems="center">
          {" "}
          {/* <Grid item xs={3}>
            <Avatar variant="square" />
          </Grid> */}
          <Grid item md={12}>
            <Paper>
              <form>
                <h2>Личные данные</h2>
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Имя
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.name}
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(
                            /[^А-Яа-яәіңғүұқөһӘІҢҒҮҰҚӨҺ]/gi,
                            ""
                          );

                          this.setState({
                            name: value,
                          });
                        }}
                        disabled={this.state.isEditable}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Фамилия
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.surname}
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(
                            /[^А-Яа-яәіңғүұқөһӘІҢҒҮҰҚӨҺ]/gi,
                            ""
                          );

                          this.setState({
                            surname: value,
                          });
                        }}
                        disabled={this.state.isEditable}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Отчество
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.patronymic}
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(
                            /[^А-Яа-яәіңғүұқөһӘІҢҒҮҰҚӨҺ]/gi,
                            ""
                          );

                          this.setState({
                            patronymic: value,
                          });
                        }}
                        disabled={this.state.isEditable}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Имя (транслитом)
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.nameInLatin}
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(/[^A-Za-z]/gi, "");

                          this.setState({
                            nameInLatin: value,
                          });
                        }}
                        disabled={this.state.isEditable}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Фамилия (транслитом)
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.surnameInLatin}
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(/[^A-Za-z]/gi, "");

                          this.setState({
                            surnameInLatin: value,
                          });
                        }}
                        disabled={this.state.isEditable}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Телефон
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      {/* <PhoneInput
                        style={{
                          width: "100%",
                          padding: "18.5px 14px",
                          fontSize: "1rem",
                          fontFamily:
                            '"Roboto", "Helvetica", "Arial", sans-serif',
                          borderColor: "rgba(0, 0, 0, 0.23)",
                          borderRadius: "4px",
                        }}
                        value={this.state.phoneNumber}
                        onChange={(phoneNumber) =>
                          this.setState({ phoneNumber })
                        }
                      ></PhoneInput> */}
                      <MuiTelInput
                        fullWidth
                        required
                        inputRef={myRefNumber}
                        variant="outlined"
                        value={this.state.phoneNumber}
                        onChange={(e) => this.handlePhoneChange(e)}
                        disabled={this.state.isEditable}
                        defaultCountry="KZ"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Национальность
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        select
                        children
                        defaultValue=""
                        value={this.state.nationality}
                        onChange={(e) => {
                          this.setState({
                            nationality: e.target.value,
                          });
                        }}
                        disabled={this.state.isEditable}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {this.nationalities.map((option) => (
                          <MenuItem key={option.id} value={option.value}>
                            {option.label}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Гражданство
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        select
                        children
                        defaultValue=""
                        fullWidth
                        value={this.state.citizenship}
                        disabled={this.state.isEditable}
                        SelectProps={{
                          MenuProps: { autoFocus: false },
                        }}
                        onChange={(e) =>
                          this.setState({
                            citizenship: e.target.value,
                          })
                        }
                        onClose={() =>
                          this.setState({
                            searchText: "",
                          })
                        }
                      >
                        <ListSubheader>
                          <TextField
                            size="small"
                            autoFocus
                            placeholder="Введите для поиска или выберите в меню"
                            fullWidth
                            onChange={(e) => this.filter(e)}
                            onKeyDown={(e) => {
                              if (e.key !== "Escape") {
                                e.stopPropagation();
                              }
                            }}
                            inputProps={{
                              style: { backgroundColor: "white" },
                            }}
                          />
                        </ListSubheader>
                        {this.state.resultText.map((country) => (
                          <MenuItem key={country.id} value={country.id}>
                            {country.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Страна, откуда прибыл
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        select
                        children
                        defaultValue=""
                        fullWidth
                        value={this.state.foreignCountry}
                        disabled={this.state.isEditable}
                        SelectProps={{
                          MenuProps: { autoFocus: false },
                        }}
                        // onChange={(e) =>
                        //   this.setState({
                        //     foreignCountry: e.target.value,
                        //   })
                        // }
                        onChange={this.handleChangeForeignCountry}
                        onClose={() =>
                          this.setState({
                            searchText: "",
                          })
                        }
                      >
                        <ListSubheader>
                          <TextField
                            size="small"
                            autoFocus
                            placeholder="Введите для поиска или выберите в меню"
                            fullWidth
                            onChange={(e) => this.filter(e)}
                            onKeyDown={(e) => {
                              if (e.key !== "Escape") {
                                e.stopPropagation();
                              }
                            }}
                            inputProps={{
                              style: { backgroundColor: "white" },
                            }}
                          />
                        </ListSubheader>
                        {this.state.resultText.map((country) => (
                          <MenuItem key={country.id} value={country.id}>
                            {country.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                {this.state.showKazakhstanFields && (
                  <>
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={5} style={{ marginLeft: "10px" }}>
                          <Typography id="input-slider-1" gutterBottom>
                            Область прописки (КАТО)
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            select
                            children
                            defaultValue=""
                            value={this.state.selectedRegionResidence}
                            onChange={(e) => {
                              this.setState({
                                selectedRegionResidence: e.target.value,
                              });
                              this.getAllKatoPlacesByRegion(
                                e.target.value,
                                "residence"
                              );
                            }}
                            disabled={this.state.isEditable}
                          >
                            <MenuItem value="none" disabled>
                              Выберите один из вариантов
                            </MenuItem>

                            {this.state.regions.map((region) => (
                              <MenuItem key={region.id} value={region.codePrefix}>
                                {region.nameru}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid>
                    <br />

                    {this.state.selectedRegionResidence && (
                      <>
                        <Grid item md={9}>
                          <Grid container spacing={2}>
                            <Grid item xs={5} style={{ marginLeft: "10px" }}>
                              <Typography id="input-slider-1" gutterBottom>
                                Районный центр прописки (КАТО)
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                variant="outlined"
                                select
                                children
                                defaultValue=""
                                SelectProps={{
                                  MenuProps: { autoFocus: false },
                                }}
                                disabled={this.state.isEditable}
                                value={this.state.selectedResidenceAddress}
                                onChange={(e) => {
                                  this.setState({
                                    selectedResidenceAddress: e.target.value,
                                  });
                                }}
                                onClose={() =>
                                  this.setState({
                                    searchText: "",
                                  })
                                }
                              >
                                <ListSubheader>
                                  <TextField
                                    size="small"
                                    autoFocus
                                    placeholder="Введите для поиска или выберите в меню"
                                    fullWidth
                                    onChange={(e) =>
                                      this.filterPlaces(e, "residence")
                                    }
                                    onKeyDown={(e) => {
                                      if (e.key !== "Escape") {
                                        e.stopPropagation();
                                      }
                                    }}
                                    inputProps={{
                                      style: { backgroundColor: "white" },
                                    }}
                                  />
                                </ListSubheader>
                                {this.state.residenceResultPlaces.map((place) => (
                                  <MenuItem key={place.id} value={place.id}>
                                    {place.nameru}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                          </Grid>
                        </Grid>
                      </>
                    )}
                    <br />
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={5} style={{ marginLeft: "10px" }}>
                          <Typography id="input-slider-1" gutterBottom>
                            Область проживания (КАТО)
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            select
                            children
                            defaultValue=""
                            disabled={this.state.isEditable}
                            value={this.state.selectedRegionLife}
                            onChange={(e) => {
                              this.setState({
                                selectedRegionLife: e.target.value,
                              });
                              this.getAllKatoPlacesByRegion(e.target.value, "life");
                            }}
                          >
                            <MenuItem value="none" disabled>
                              Выберите один из вариантов
                            </MenuItem>

                            {this.state.regions.map((region) => (
                              <MenuItem key={region.id} value={region.codePrefix}>
                                {region.nameru}
                              </MenuItem>
                            ))}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid>
                    <br />
                    {this.state.selectedRegionLife && (
                      <>
                        <Grid item md={9}>
                          <Grid container spacing={2}>
                            <Grid item xs={5} style={{ marginLeft: "10px" }}>
                              <Typography id="input-slider-1" gutterBottom>
                                Районный центр проживания (КАТО)
                              </Typography>
                            </Grid>
                            <Grid item xs={6}>
                              <TextField
                                fullWidth
                                variant="outlined"
                                select
                                children
                                disabled={this.state.isEditable}
                                value={this.state.selectedLifeAddress}
                                SelectProps={{
                                  MenuProps: { autoFocus: false },
                                }}
                                onChange={(e) => {
                                  this.setState({
                                    selectedLifeAddress: e.target.value,
                                  });
                                }}
                                onClose={() =>
                                  this.setState({
                                    searchText: "",
                                  })
                                }
                              >
                                <ListSubheader>
                                  <TextField
                                    size="small"
                                    autoFocus
                                    placeholder="Введите для поиска или выберите в меню"
                                    fullWidth
                                    onChange={(e) => this.filterPlaces(e, "life")}
                                    onKeyDown={(e) => {
                                      if (e.key !== "Escape") {
                                        e.stopPropagation();
                                      }
                                    }}
                                    inputProps={{
                                      style: { backgroundColor: "white" },
                                    }}
                                  />
                                </ListSubheader>
                                {this.state.lifeResultPlaces.map((place) => (
                                  <MenuItem key={place.id} value={place.id}>
                                    {place.nameru}
                                  </MenuItem>
                                ))}
                              </TextField>
                            </Grid>
                          </Grid>
                        </Grid>
                      </>
                    )}
                  </>
                )}
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Фактический адрес проживания
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.factAddress}
                        disabled={this.state.isEditable}
                        onChange={(e) => {
                          this.setState({ factAddress: e.target.value });
                        }}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        E-mail
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.email}
                        disabled={this.state.isEditable}
                        onChange={(e) => {
                          this.setState({ email: e.target.value });
                        }}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Дата рождения
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        type="date"
                        fullWidth
                        variant="outlined"
                        value={this.state.dateOfBirth}
                        disabled={this.state.isEditable}
                        onChange={(e) => {
                          this.setState({
                            dateOfBirth: e.target.value,
                          });
                        }}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2} style={{ alignItems: "center" }}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        3x4 фото
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <FileUpload
                        helperText="Фото 3x4 (.png, .jpeg)"
                        fileType={Constants.FILE_TYPES.image3x4}
                        file={this.state?.imageID}
                        filePath={this.state.imagePath}
                        userId={this.props.id}
                        handleSetFileId={(fileId) =>
                          this.setState({ imageID: fileId })
                        }
                        handleDelete={() => {
                          this.fetchData();
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2} style={{ alignItems: "center" }}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Имеется сельская квота
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Checkbox
                        checked={this.state.ruralQuote}
                        disabled={this.state.isEditable}
                        onChange={() =>
                          this.setState({ ruralQuote: !this.state.ruralQuote })
                        }
                        color="primary"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        ИИН
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        required
                        inputRef={myRefIin}
                        margin="normal"
                        label="ИИН"
                        disabled={this.state.isEditable}
                        onChange={(e) => {
                          let value = e.target.value;

                          value = value.replace(/[^0-9]/gi, "");

                          this.setState({
                            iin: value,
                          });
                        }}
                        value={this.state.iin}
                        error={
                          this.state.iin?.length < 12 &&
                          this.state.iin?.length > 0
                        }
                        helperText={
                          this.state.iin?.length < 12 &&
                            this.state.iin?.length > 0
                            ? "ИИН не может быть меньше 12 цифр"
                            : " "
                        }
                        inputProps={{ maxLength: 12 }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Пол
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        fullWidth
                        value={this.state.isMale}
                        label="Пол"
                        disabled={this.state.isEditable}
                        onChange={(e) => {
                          this.setState({
                            isMale: e.target.value,
                          });
                        }}
                      >
                        <MenuItem value={"true"} key={0}>
                          Мужской
                        </MenuItem>
                        <MenuItem value={"false"} key={1}>
                          Женский
                        </MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Общежитие
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        fullWidth
                        value={this.state.needDorm}
                        label="Общежитие"
                        disabled={this.state.isEditable}
                        onChange={(e) => {
                          this.setState({
                            needDorm: e.target.value,
                          });
                        }}
                      >
                        <MenuItem value={"true"} key={0}>
                          Нуждается
                        </MenuItem>
                        <MenuItem value={"false"} key={1}>
                          Не нуждается
                        </MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Семейное положение
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        fullWidth
                        value={this.state.isMarried}
                        label="Семейное положение"
                        disabled={this.state.isEditable}
                        onChange={(e) => {
                          this.setState({
                            isMarried: e.target.value,
                          });
                        }}
                      >
                        <MenuItem value={"true"} key={0}>
                          Женат/Замужем
                        </MenuItem>
                        <MenuItem value={"false"} key={1}>
                          Холост/Не замужем
                        </MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Проживает в городе Астана
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        fullWidth
                        value={this.state.isLocal}
                        label="Проживает в городе Астана"
                        disabled={this.state.isEditable}
                        onChange={(e) => {
                          this.setState({
                            isLocal: e.target.value,
                          });
                        }}
                      >
                        <MenuItem value={"true"} key={0}>
                          Да
                        </MenuItem>
                        <MenuItem value={"false"} key={1}>
                          Нет
                        </MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Имя первого родителя(опекуна)
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        required
                        inputRef={myRefName}
                        fullWidth
                        variant="outlined"
                        value={this.state.firstParentName}
                        disabled={this.state.isEditable}
                        onChange={(e) =>
                          this.setState({
                            firstParentName: e.target.value,
                          })
                        }
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Фамилия первого родителя(опекуна)
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        required
                        inputRef={myRefSurname}
                        variant="outlined"
                        value={this.state.firstParentSurname}
                        disabled={this.state.isEditable}
                        onChange={(e) =>
                          this.setState({
                            firstParentSurname: e.target.value,
                          })
                        }
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Отчество первого родителя(опекуна)
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.firstParentPatronymic}
                        disabled={this.state.isEditable}
                        onChange={(e) =>
                          this.setState({
                            firstParentPatronymic: e.target.value,
                          })
                        }
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Телефон первого родителя(опекуна)
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      {/* <TextField
                        fullWidth
                        variant="outlined"
                        required
                        inputRef={myRefNumber}
                        value={this.state.firstParentPhoneNumber}
                        type="tel"
                        onChange={(e) =>
                          this.setState({
                            firstParentPhoneNumber: e.target.value,
                          })
                        }
                      ></TextField> */}
                      <MuiTelInput
                        fullWidth
                        required
                        inputRef={myRefNumber}
                        disabled={this.state.isEditable}
                        variant="outlined"
                        value={this.state.firstParentPhoneNumber}
                        onChange={(e) =>
                          this.handleFirstParentPhoneNumberChange(e)
                        }
                        defaultCountry="KZ"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Имя второго родителя
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.secondParentName}
                        disabled={this.state.isEditable}
                        onChange={(e) =>
                          this.setState({
                            secondParentName: e.target.value,
                          })
                        }
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Фамилия второго родителя
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.secondParentSurname}
                        disabled={this.state.isEditable}
                        onChange={(e) =>
                          this.setState({
                            secondParentSurname: e.target.value,
                          })
                        }
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Отчество второго родителя
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.secondParentPatronymic}
                        disabled={this.state.isEditable}
                        onChange={(e) =>
                          this.setState({
                            secondParentPatronymic: e.target.value,
                          })
                        }
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Телефон второго родителя
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      {/* <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.secondParentPhoneNumber}
                        onChange={(e) =>
                          this.setState({
                            secondParentPhoneNumber: e.target.value,
                          })
                        }
                      ></TextField> */}
                      <MuiTelInput
                        fullWidth
                        required
                        inputRef={myRefNumber}
                        disabled={this.state.isEditable}
                        variant="outlined"
                        value={this.state.secondParentPhoneNumber}
                        onChange={(e) =>
                          this.handleSecondParentPhoneNumberChange(e)
                        }
                        defaultCountry="KZ"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Социальный статус
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        fullWidth
                        value={this.state.socialStatus}
                        disabled={this.state.isEditable}
                        onChange={(e) => {
                          this.setState({
                            socialStatus: e.target.value,
                          });
                        }}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {this.state.socialStatusTypes.map(
                          (socialStatusType) => (
                            <MenuItem
                              key={socialStatusType.id}
                              value={socialStatusType.id}
                            >
                              {socialStatusType.name}
                            </MenuItem>
                          )
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Документ подтверждающий социальный статус
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <FileUpload
                        helperText="Документ подтверждающий социальный статус (в формате pdf)"
                        fileType={
                          Constants.FILE_TYPES.documentConfirmingSocialStatus
                        }
                        file={this.state.socialStatusFileId}
                        filePath={this.state.socialStatusPath}
                        userId={this.props.id}
                        handleSetFileId={(fileId) =>
                          this.setState({ socialStatusFileId: fileId })
                        }
                        handleDelete={() => {
                          this.fetchData();
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <h2>Документы</h2>
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Вид документа
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        select
                        children
                        defaultValue=""
                        value={this.state.selectedIdentityDocumentType}
                        disabled={this.state.isEditable}
                        onChange={(event) =>
                          this.setState({
                            selectedIdentityDocumentType: event.target.value,
                          })
                        }
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {this.state.documents.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                {this.state.selectedIdentityDocumentType &&
                  this.state.selectedIdentityDocumentType === 5 && (
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={5} style={{ marginLeft: "10px" }}>
                          <Typography id="input-slider-1" gutterBottom>
                            Тип документа
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            value={this.state.selectedOtherDocumentType}
                            onChange={(event) =>
                              this.setState({
                                selectedOtherDocumentType: event.target.value,
                              })
                            }
                            disabled={this.state.isEditable}
                          ></TextField>
                        </Grid>
                      </Grid>
                      <br></br>
                    </Grid>
                  )}

                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Номер документа
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        value={this.state.selectedIdentityDocumentNumber}
                        onChange={(event) =>
                          this.setState({
                            selectedIdentityDocumentNumber: event.target.value,
                          })
                        }
                        disabled={this.state.isEditable}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Дата выдачи документа
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        type="date"
                        value={this.state.selectedIdentityDocumentIssueDate}
                        onChange={(event) =>
                          this.setState({
                            selectedIdentityDocumentIssueDate:
                              event.target.value,
                          })
                        }
                        disabled={this.state.isEditable}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Срок действия документа
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        variant="outlined"
                        type="date"
                        value={
                          this.state.selectedIdentityDocumentValidityPeriod
                        }
                        onChange={(event) =>
                          this.setState({
                            selectedIdentityDocumentValidityPeriod:
                              event.target.value,
                          })
                        }
                        disabled={this.state.isEditable}
                      ></TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Орган выдачи документа, удостоверяющий личность
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        select
                        children
                        defaultValue=""
                        disabled={this.state.isEditable}
                        value={this.state.selectedIssuingAuthority}
                        onChange={(event) =>
                          this.setState({
                            selectedIssuingAuthority: event.target.value,
                          })
                        }
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {this.state.institutions.map((option) => (
                          <MenuItem key={option.id} value={option.id}>
                            {option.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Лицевая сторона документа
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      {/* {abiturInformation?.identityDocumentScanFront && (
                        <Button
                          color="primary"
                          variant="contained"
                          fullWidth
                          onClick={() =>
                            this.DownloadFile(
                              this.props.id,
                              abiturInformation?.identityDocumentScanFront?.id,
                              abiturInformation?.identityDocumentScanFront?.path
                            )
                          }
                        >
                          Скачать ранее загруженный документ(Скан документа,
                          удостоверяющий личность (лицевая сторона))
                        </Button>
                      )} */}
                      <FileUpload
                        helperText="Скан документа, удостоверяющий личность (лицевая сторона)"
                        fileType={Constants.FILE_TYPES.identityFront}
                        file={this.state.identityFront}
                        filePath={this.state.identityFrontPath}
                        userId={this.props.id}
                        handleSetFileId={(fileId) =>
                          this.setState({ identityFront: fileId })
                        }
                        handleDelete={() => {
                          this.fetchData();
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2} style={{ alignItems: "center" }}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Обратная сторона документа
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <FileUpload
                        helperText="Скан документа, удостоверяющий личность (обратная сторона)"
                        fileType={Constants.FILE_TYPES.identityBack}
                        file={this.state.identityBack}
                        filePath={this.state.identityBackPath}
                        userId={this.props.id}
                        handleSetFileId={(fileId) =>
                          this.setState({ identityBack: fileId })
                        }
                        handleDelete={() => {
                          this.fetchData();
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Медицинская справка 075
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <FileUpload
                        helperText="Скан справки 075"
                        fileType={Constants.FILE_TYPES.form086}
                        file={this.state.form086}
                        filePath={this.state.form086Path}
                        userId={this.props.id}
                        handleSetFileId={(fileId) =>
                          this.setState({ form086: fileId })
                        }
                        handleDelete={() => {
                          this.fetchData();
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Документа, подтверждающего наличие внутреннего гранта
                        (победители олимпиад AITU iCode \ AITU Open \
                        Международная Жаутыковская Олимпиада)
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <FileUpload
                        helperText="Документ, подтверждающий наличие внутреннего гранта"
                        fileType={
                          Constants.FILE_TYPES
                            .documentConfirmingAvailabilityOfInternalGrant
                        }
                        file={
                          this.state
                            .documentConfirmingAvailabilityOfInternalGrantScan
                        }
                        filePath={
                          this.state
                            .documentConfirmingAvailabilityOfInternalGrantScanPath
                        }
                        userId={this.props.id}
                        handleSetFileId={(fileId) =>
                          this.setState({
                            documentConfirmingAvailabilityOfInternalGrantScan:
                              fileId,
                          })
                        }
                        handleDelete={() => {
                          this.fetchData();
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Приписной билет
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <FileUpload
                        helperText="Приписной билет"
                        fileType={Constants.FILE_TYPES.pripisnoiBilet}
                        file={this.state.pripisnoiBiletScan}
                        filePath={this.state.pripisnoiBiletPath}
                        userId={this.props.id}
                        handleSetFileId={(fileId) =>
                          this.setState({
                            pripisnoiBiletScan: fileId,
                          })
                        }
                        handleDelete={() => {
                          this.fetchData();
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <h2>Сведение об образования</h2>
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Закончил образовательное учреждение
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        select
                        children
                        defaultValue=""
                        value={this.state.selectedEducationInstitutionType}
                        onChange={(event) =>
                          this.setState({
                            selectedEducationInstitutionType:
                              event.target.value,
                          })
                        }
                        disabled={this.state.isEditable}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {this.state.educationInstitutionTypes.map(
                          (educationInstitutionType) => (
                            <MenuItem
                              key={educationInstitutionType.id}
                              value={educationInstitutionType.id}
                            >
                              {educationInstitutionType.name}
                            </MenuItem>
                          )
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        На каком языке обучался в предыдущем образовательном учреждении
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        value={this.state.selectedLanguage}
                        onChange={(event) =>
                          this.setState({
                            selectedLanguage: event.target.value,
                          })
                        }
                        disabled={this.state.isEditable}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {this.state.languages.map((language) => {
                          return (
                            <MenuItem
                              key={language.id}
                              value={language.id}
                            >
                              {language.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Место окончания учебного заведения
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        fullWidth
                        value={this.state.graduationPlaceCity}
                        // label="Место окончания учебного заведения"
                        disabled={this.state.isEditable}
                        onChange={(e) => {
                          this.setState({
                            graduationPlaceCity: e.target.value,
                          });
                        }}
                      >
                        <MenuItem value={"true"} key={0}>
                          Город
                        </MenuItem>
                        <MenuItem value={"false"} key={1}>
                          Село
                        </MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                {this.state.selectedEducationInstitutionType &&
                  this.state.selectedEducationInstitutionType === 1 && (
                    <>{schoolGraduate}</>
                  )}
                {this.state.selectedEducationInstitutionType &&
                  this.state.selectedEducationInstitutionType !== 1 && (
                    <>{collegeGraduate}</>
                  )}
                <h2>Сведения о поступлении </h2>

                <Grid item md={9}>
                  {(this.state.aetEnglishPoint || this.state.aetIctPoint) && (
                    <Alert severity="success">
                      <AlertTitle>Результаты АЕТ</AlertTitle>
                      {this.state.aetEnglishPoint && (
                        <Typography>
                          Баллы за английский язык -{" "}
                          {this.state.aetEnglishPoint}
                        </Typography>
                      )}
                      {this.state.aetIctPoint && (
                        <Typography>
                          Баллы за ИКТ - {this.state.aetIctPoint}
                        </Typography>
                      )}
                    </Alert>
                  )}
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Академическая степень
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        value={this.state.selectedAcademicDegree}
                        disabled={this.state.isEditable}
                        onChange={(event) => {
                          this.setState({
                            selectedAcademicDegree: event.target.value,
                          });
                          this.handleSelectedAcademicDegree(event.target.value);
                        }}
                      >
                        {this.state.academicDegrees.map((academicDegree) => (
                          <MenuItem
                            key={academicDegree.id}
                            value={academicDegree.id}
                          >
                            {academicDegree.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                {this.state.selectedAcademicDegree && (
                  <>
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={5} style={{ marginLeft: "10px" }}>
                          <Typography id="input-slider-1" gutterBottom>
                            Образовательная программа
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            select
                            children
                            defaultValue=""
                            variant="outlined"
                            onChange={(event) => {
                              this.setState({
                                selectedEducationalProgram: event.target.value,
                              });
                              this.handleSelectEducationalProgram(
                                event.target.value
                              );
                            }}
                            value={this.state.selectedEducationalProgram}
                            disabled={this.state.isEditable}
                          >
                            <MenuItem value="none" disabled>
                              Выберите один из вариантов
                            </MenuItem>
                            {this.state.educationalPrograms.map(
                              (educationalProgram) => (
                                <MenuItem
                                  key={educationalProgram.id}
                                  value={educationalProgram.id}
                                >
                                  {`${educationalProgram.titleEn} ${this.state.abiturInfo?.educationalProgram ? `- ${this.state.abiturInfo?.educationalProgram?.code}` : ``}`}
                                </MenuItem>
                              )
                            )}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid>
                    <br />
                  </>
                )}

                {/* <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography gutterBottom>
                        Программа финансирования
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        select
                        variant="outlined"
                        defaultValue=""
                        onChange={(e) => {
                          this.setState({
                            selectedFinancingProgram: e.target.value,
                          });
                        }}
                        disabled={this.state.isEditable}
                        value={this.state.selectedFinancingProgram}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {this.state.financingPrograms.map(
                          (financingProgram) => {
                            return (
                              <MenuItem
                                key={financingProgram.id}
                                value={financingProgram.id}
                              >
                                {financingProgram.name}
                              </MenuItem>
                            );
                          }
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid> */}
                <br />


                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Вид экзамена
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        value={this.state.selectedExamType}
                        onChange={(event) =>
                          this.setState({
                            selectedExamType: event.target.value,
                          })
                        }
                        disabled={this.state.isEditable}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {this.state.examTypes.map((examType) => {
                          if (
                            this.state.selectedAcademicDegree === 2 &&
                            examType.name.includes("ЕНТ")
                          ) {
                            return null;
                          }
                          if (
                            this.state.selectedAcademicDegree === 2 &&
                            examType.name.includes("Собеседование")
                          ) {
                            return null;
                          }
                          if (
                            this.state.selectedAcademicDegree === 1 &&
                            examType.name.includes("Комплексное тестирование")
                          ) {
                            return null;
                          }

                          return (
                            <MenuItem key={examType.id} value={examType.id}>
                              {examType.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Язык сдачи экзамена
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        value={this.state.selectedExamLanguage}
                        onChange={(event) =>
                          this.setState({
                            selectedExamLanguage: event.target.value,
                          })
                        }
                        disabled={this.state.isEditable}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {this.state.examLanguages.map((examLanguage) => {
                          return (
                            <MenuItem
                              key={examLanguage.id}
                              value={examLanguage.id}
                            >
                              {examLanguage.name}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                {(this.state.selectedExamType !== 2) && (
                    <>
                      <br />
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography gutterBottom>
                              Сумма баллов по результатам ЕНТ/КТ по профилю (общепрофильные предметы и профилирующие предметы)
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              type={"number"}
                              onChange={(e) => {
                                this.setState({
                                  examMark: e.target.value,
                                });
                              }}
                              value={this.state.examMark}
                              disabled={this.state.isEditable}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}
                {this.state.selectedExamType === 3 && (
                  <>
                    <br />
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={5} style={{ marginLeft: "10px" }}>
                          <Typography id="input-slider-1" gutterBottom>
                            Сертификат КТ
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <FileUpload
                            helperText="Сертификат КТ"
                            fileType={Constants.FILE_TYPES.entCertificate}
                            file={this.state.entCertificateScan}
                            filePath={this.state.entCertificateScanPath}
                            userId={this.props.id}
                            handleSetFileId={(fileId) =>
                              this.setState({ entCertificateScan: fileId })
                            }
                            handleDelete={() => {
                              this.fetchData();
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                )}

                {this.state.selectedEducationalProgram &&
                  (this.state.selectedAcademicDegree === 1 ||
                    this.state.selectedAcademicDegree === 2) &&
                  (this.state.selectedExamType === 1 ||
                    this.state.selectedExamType === 3 ||
                    this.state.selectedExamType === 4) &&
                  this.state.selectedEducationalProgram !== 4 && (
                    <>
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Индивидуальный Код Тестируемого
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              onChange={(e) => {
                                this.setState({
                                  individualTestingCode: e.target.value,
                                });
                              }}
                              value={this.state.individualTestingCode}
                              disabled={this.state.isEditable}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <br />
                    </>
                  )}
                {this.state.selectedEducationalProgram &&
                  this.state.selectedAcademicDegree === 1 &&
                  this.state.selectedExamType === 1 &&
                  this.state.selectedEducationalProgram !== 4 && (
                    <>
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Балл за грамотность чтения
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              value={
                                this.state.entDetails?.readingLiteracyPoint
                              }
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  entDetails: {
                                    ...prevState.entDetails,
                                    readingLiteracyPoint: e.target.value,
                                  },
                                }));
                              }}
                              disabled={this.state.isEditable}
                            ></TextField>
                          </Grid>
                        </Grid>
                      </Grid>
                      <br />
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Балл за историю Казахстана
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              value={
                                this.state.entDetails?.kazakhstanHistoryPoint
                              }
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  entDetails: {
                                    ...prevState.entDetails,
                                    kazakhstanHistoryPoint: e.target.value,
                                  },
                                }));
                              }}
                              disabled={this.state.isEditable}
                            ></TextField>
                          </Grid>
                        </Grid>
                      </Grid>
                      <br />
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Математическая грамотность
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              value={
                                this.state.entDetails?.mathematicalLiteracyPoint
                              }
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  entDetails: {
                                    ...prevState.entDetails,
                                    mathematicalLiteracyPoint: e.target.value,
                                  },
                                }));
                              }}
                              disabled={this.state.isEditable}
                            ></TextField>
                          </Grid>
                        </Grid>
                      </Grid>
                      <br />

                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              {
                                this.state.selectedEducationalProgramGroup
                                  ?.subject1?.title
                              }
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography gutterBottom>
                              <TextField
                                variant="outlined"
                                fullWidth
                                value={
                                  this.state.entDetails?.profileSubject1Point
                                }
                                onChange={(e) => {
                                  this.setState((prevState) => ({
                                    entDetails: {
                                      ...prevState.entDetails,
                                      profileSubject1Point: e.target.value,
                                    },
                                  }));
                                }}
                                disabled={this.state.isEditable}
                              ></TextField>
                            </Typography>
                          </Grid>
                        </Grid>
                        <br />
                      </Grid>

                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              {
                                this.state.selectedEducationalProgramGroup
                                  ?.subject2?.title
                              }
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <Typography gutterBottom>
                              <TextField
                                variant="outlined"
                                fullWidth
                                value={
                                  this.state.entDetails?.profileSubject2Point
                                }
                                onChange={(e) => {
                                  this.setState((prevState) => ({
                                    entDetails: {
                                      ...prevState.entDetails,
                                      profileSubject2Point: e.target.value,
                                    },
                                  }));
                                }}
                                disabled={this.state.isEditable}
                              ></TextField>
                            </Typography>
                          </Grid>
                        </Grid>
                      </Grid>
                      <br />
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Сертификат ЕНТ
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <FileUpload
                              helperText="Сертификат ЕНТ (скан)"
                              fileType={Constants.FILE_TYPES.entCertificate}
                              file={this.state.entCertificateScan}
                              filePath={this.state.entCertificateScanPath}
                              userId={this.props.id}
                              handleSetFileId={(fileId) =>
                                this.setState({ entCertificateScan: fileId })
                              }
                              handleDelete={() => {
                                this.fetchData();
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}
                {this.state.selectedExamType === 1 &&
                  this.state.selectedEducationalProgram === 4 && (
                    <>
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Балл за грамотность чтения
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              value={
                                this.state.entDetails?.readingLiteracyPoint
                              }
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  entDetails: {
                                    ...prevState.entDetails,
                                    readingLiteracyPoint: e.target.value,
                                  },
                                }));
                              }}
                              disabled={this.state.isEditable}
                            ></TextField>
                          </Grid>
                        </Grid>
                      </Grid>
                      <br />
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Балл за историю Казахстана
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              value={
                                this.state.entDetails?.kazakhstanHistoryPoint
                              }
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  entDetails: {
                                    ...prevState.entDetails,
                                    kazakhstanHistoryPoint: e.target.value,
                                  },
                                }));
                              }}
                              disabled={this.state.isEditable}
                            ></TextField>
                          </Grid>
                        </Grid>
                      </Grid>
                      <br />
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Математическая грамотность
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              value={
                                this.state.entDetails?.mathematicalLiteracyPoint
                              }
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  entDetails: {
                                    ...prevState.entDetails,
                                    mathematicalLiteracyPoint: e.target.value,
                                  },
                                }));
                              }}
                              disabled={this.state.isEditable}
                            ></TextField>
                          </Grid>
                        </Grid>
                      </Grid>
                      <br />
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Творческий экзамен
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              variant="outlined"
                              fullWidth
                              value={
                                this.state.creativeExamPoints
                              }
                              onChange={(e) => {
                                this.setState((prevState) => ({
                                  creativeExamPoints: e.target.value,
                                }));
                              }}
                              disabled={this.state.isEditable}
                            ></TextField>
                          </Grid>
                        </Grid>
                      </Grid>
                      <br />
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Сертификат ЕНТ
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <FileUpload
                              helperText="Сертификат ЕНТ (скан)"
                              fileType={Constants.FILE_TYPES.entCertificate}
                              file={this.state.entCertificateScan}
                              filePath={this.state.entCertificateScanPath}
                              userId={this.props.id}
                              handleSetFileId={(fileId) =>
                                this.setState({ entCertificateScan: fileId })
                              }
                              handleDelete={() => {
                                this.fetchData();
                              }}
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                    </>
                  )}

                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Тип английского экзамена
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography gutterBottom>
                        <TextField
                          variant="outlined"
                          fullWidth
                          select
                          children
                          defaultValue=""
                          onChange={(e) => {
                            this.setState({
                              selectedEnglishCertificateType: e.target.value,
                            });
                          }}
                          value={this.state.selectedEnglishCertificateType}
                          disabled={this.state.isEditable}
                        >
                          <MenuItem value="none" disabled>
                            Выберите один из вариантов
                          </MenuItem>
                          {this.state.englishCertificateTypes.map(
                            (englishCertificateType) => {
                              if (
                                this.state.selectedAcademicDegree === 2 &&
                                englishCertificateType.name.includes(
                                  "AITU Excelence Test"
                                )
                              ) {
                                return null;
                              }
                              if (
                                this.state.selectedAcademicDegree === 2 &&
                                englishCertificateType.name.includes(
                                  "Foundation AITU"
                                )
                              ) {
                                return null;
                              }
                              if (
                                this.state.selectedAcademicDegree === 2 &&
                                englishCertificateType.name.includes(
                                  "Олимпиада iQyn"
                                )
                              ) {
                                return null;
                              }
                              if (
                                this.state.selectedAcademicDegree === 2 &&
                                englishCertificateType.name.includes("Duolingo")
                              ) {
                                return null;
                              }
                              if (
                                this.state.selectedAcademicDegree === 1 &&
                                englishCertificateType.name.includes("GMAT")
                              ) {
                                return null;
                              }

                              return (
                                <MenuItem
                                  key={englishCertificateType.id}
                                  value={englishCertificateType.id}
                                >
                                  {englishCertificateType.name}
                                </MenuItem>
                              );
                            }
                          )}
                        </TextField>
                      </Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Сертификат английского
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <FileUpload
                        helperText="Скан сертификата, подтверждающего знания английского языка"
                        fileType={Constants.FILE_TYPES.englishCertificate}
                        file={this.state.englishExamScan}
                        filePath={this.state.englishExamScanPath}
                        userId={this.props.id}
                        handleSetFileId={(fileId) =>
                          this.setState({ englishExamScan: fileId })
                        }
                        handleDelete={() => {
                          this.fetchData();
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography gutterBottom>
                        Тип сертификата олимпийского призёра
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        select
                        variant="outlined"
                        label="Выберите тип имеющегося у вас сертификата олимпийского призёра"
                        defaultValue=""
                        onChange={(e) => {
                          this.setState({
                            selectedOlympiadCertificateType: e.target.value,
                          });
                        }}
                        disabled={this.state.isEditable}
                        value={this.state.selectedOlympiadCertificateType}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {this.state.olympiadCertificateTypes.map(
                          (olympiadCertificateType) => {
                            return (
                              <MenuItem
                                key={olympiadCertificateType.id}
                                value={olympiadCertificateType.id}
                              >
                                {olympiadCertificateType.name}
                              </MenuItem>
                            );
                          }
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />

                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Результаты (баллы) экзамена на знание английского языка
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        variant="outlined"
                        fullWidth
                        type="number"
                        onChange={(event) =>
                          this.setState({
                            // kzGraduationCertificateSeries: event.target.value,
                            englishCertificatePoints: event.target.value,
                          })
                        }
                        value={this.state.englishCertificatePoints}
                        disabled={this.state.isEditable}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                {selectedAcademicDegree === 1 && this.isCertificateValid(selectedEnglishCertificateType, englishCertificatePoints) && (

                  <>
                    <br />
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={5} style={{ marginLeft: "10px" }}>
                          <Typography gutterBottom>
                            Какой курс вы бы хотели пройти вместо английского языка
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            select
                            variant="outlined"
                            defaultValue=""
                            onChange={(e) => {
                              this.setState({
                                selectedAdditionalCourse: e.target.value,
                              });
                            }}
                            disabled={this.state.isEditable}
                            value={this.state.selectedAdditionalCourse}
                          >
                            <MenuItem value="none" disabled>
                              Выберите один из вариантов
                            </MenuItem>
                            {this.state.additionalCourses.map(
                              (additionalCourse) => {
                                return (
                                  <MenuItem
                                    key={additionalCourse.id}
                                    value={additionalCourse.id}
                                  >
                                    {additionalCourse.name}
                                  </MenuItem>
                                );
                              }
                            )}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid>
                    <br />
                  </>
                )}

                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography gutterBottom>
                        Сертификат олимпийского призёра
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <FileUpload
                        helperText="Скан сертификаты призёра AITU iCode, AITU Open, Жаутыковской или Евразийской олимпиады"
                        fileType={Constants.FILE_TYPES.olympiadCertificate}
                        file={this.state.olympiadCertificateScan}
                        filePath={this.state.olympiadCertificateScanPath}
                        userId={this.props.id}
                        handleSetFileId={(fileId) =>
                          this.setState({ olympiadCertificateScan: fileId })
                        }
                        handleDelete={() => {
                          this.fetchData();
                        }}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography gutterBottom>
                        Обучение по квоте (смотреть в свидетельстве о гранте)
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        select
                        variant="outlined"
                        label="Обучение по квоте (смотреть в свидетельстве о гранте)"
                        defaultValue=""
                        onChange={(e) => {
                          this.setState({
                            selectedQuota: e.target.value,
                          });
                        }}
                        disabled={this.state.isEditable}
                        value={this.state.selectedQuota}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {this.state.quotas.map(
                          (quota) => {
                            return (
                              <MenuItem
                                key={quota.id}
                                value={quota.id}
                              >
                                {quota.name}
                              </MenuItem>
                            );
                          }
                        )}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Вид обучения
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        fullWidth
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        value={this.state.selectedStudyStatus}
                        onChange={(event) => {
                          this.setState({
                            selectedStudyStatus: event.target.value,
                          });
                          this.handleSelectedStudyStatus(event.target.value);
                        }}
                        // onChange={(event) =>
                        //   this.setState({
                        //     selectedStudyStatus: event.target.value,
                        //   })
                        // }
                        disabled={this.state.isEditable}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {studyStatuses.map((studyStatus) => {
                          return (
                            <MenuItem
                              key={studyStatus.id}
                              value={studyStatus.id}
                            >
                              {studyStatus.label}
                            </MenuItem>
                          );
                        })}
                      </TextField>
                    </Grid>
                  </Grid>
                </Grid>

                <br />
                {this.state.selectedStudyStatus && (
                  <>
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={5} style={{ marginLeft: "10px" }}>
                          <Typography gutterBottom>
                            Вид финансирования
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            select
                            variant="outlined"
                            defaultValue=""
                            onChange={(e) => {
                              this.setState({
                                selectedFinancialSource: e.target.value,
                              });
                            }}
                            disabled={this.state.isEditable}
                            value={this.state.selectedFinancialSource}
                          >
                            <MenuItem value="none" disabled>
                              Выберите один из вариантов
                            </MenuItem>
                            {this.state.financialSources.map(
                              (financialSource) => {
                                return (
                                  <MenuItem
                                    key={financialSource.id}
                                    value={financialSource.id}
                                  >
                                    {financialSource.name}
                                  </MenuItem>
                                );
                              }
                            )}
                          </TextField>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                )}
                <br />
                {this.state.selectedStudyStatus === 1 && (
                  <>
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={5} style={{ marginLeft: "10px" }}>
                          <Typography id="input-slider-1" gutterBottom>
                            Скан чека об оплате
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <FileUpload
                            helperText="Скан чека об оплате"
                            fileType={Constants.FILE_TYPES.paymentReceipt}
                            file={this.state.paymentReceiptScan}
                            filePath={this.state.paymentReceiptPath}
                            userId={this.props.id}
                            handleSetFileId={(fileId) =>
                              this.setState({ paymentReceiptScan: fileId })
                            }
                            handleDelete={() => {
                              this.fetchData();
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={5} style={{ marginLeft: "10px" }}>
                          <Typography id="input-slider-1" gutterBottom>
                            Внесенная сумма
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            value={this.state.paymentAmount}
                            onChange={(e) => {
                              this.setState({ paymentAmount: e.target.value });
                            }}
                            disabled={this.state.isEditable}
                          ></TextField>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                )}
                <br />
                {this.state.selectedStudyStatus === 2 && (
                  <>
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={5} style={{ marginLeft: "10px" }}>
                          <Typography id="input-slider-1" gutterBottom>
                            Скан сертификата гранта
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <FileUpload
                            helperText="Скан сертификата гранта"
                            fileType={Constants.FILE_TYPES.grantCertificate}
                            file={this.state.grantCertificateScan}
                            filePath={this.state.grantCertificatePath}
                            userId={this.props.id}
                            handleSetFileId={(fileId) =>
                              this.setState({ grantCertificateScan: fileId })
                            }
                            handleDelete={() => {
                              this.fetchData();
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    <br />
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={5} style={{ marginLeft: "10px" }}>
                          <Typography id="input-slider-1" gutterBottom>
                            Номер сертификата гранта
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            variant="outlined"
                            fullWidth
                            value={this.state.grantDetails?.grantNumber}
                            onChange={(e) => {
                              this.setState((prevState) => ({
                                grantDetails: {
                                  ...prevState.grantDetails,
                                  grantNumber: e.target.value,
                                },
                              }));
                            }}
                            disabled={this.state.isEditable}
                          ></TextField>
                        </Grid>
                      </Grid>
                    </Grid>
                    <br />
                    <Grid item md={9}>
                      <Grid container spacing={2}>
                        <Grid item xs={5} style={{ marginLeft: "10px" }}>
                          <Typography id="input-slider-1" gutterBottom>
                            Дата выдачи сертификата гранта
                          </Typography>
                        </Grid>
                        <Grid item xs={6}>
                          <TextField
                            fullWidth
                            variant="outlined"
                            type="date"
                            value={this.state.grantDetails?.grantIssueDate}
                            onChange={(e) => {
                              this.setState((prevState) => ({
                                grantDetails: {
                                  ...prevState.grantDetails,
                                  grantIssueDate: e.target.value,
                                },
                              }));
                            }}
                            disabled={this.state.isEditable}
                          ></TextField>
                        </Grid>
                      </Grid>
                    </Grid>
                  </>
                )}
                <br />
                <h2>Достижения</h2>
                <div>
                  {this.state.achievementInfo?.map((achievement, index) => (
                    <Box key={index} style={{ marginTop: "20px" }}>
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Наименование мероприятия
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              value={achievement.eventName}
                              onChange={(e) =>
                                this.handleInputChange(index, "eventName", e.target.value)
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Наименование документа
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              value={achievement.documentName}
                              onChange={(e) =>
                                this.handleInputChange(index, "documentName", e.target.value)
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              Дата выдачи документа
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              variant="outlined"
                              type="date"
                              value={achievement.documentDate}
                              onChange={(e) =>
                                this.handleInputChange(index, "documentDate", e.target.value)
                              }
                            />
                          </Grid>
                        </Grid>
                      </Grid>
                      <Grid item md={9}>
                        <Grid container spacing={2}>
                          <Grid item xs={5} style={{ marginLeft: "10px" }}>
                            <Typography id="input-slider-1" gutterBottom>
                              СКАН-КОПИЯ ПОДТВЕРЖДАЮЩЕГО ДОКУМЕНТА
                            </Typography>
                          </Grid>
                          <Grid item xs={6}>
                            {
                              achievement.document ? (
                                <Box>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    style={{ marginRight: "20px" }}
                                    onClick={() =>
                                      this.props.services.fileUpload.getDocument(
                                        achievement.document.id,
                                        achievement.document.path.split("/").pop()
                                      )
                                    }
                                  >
                                    Скачать файл
                                  </Button>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                    component="label"
                                  >
                                    <input
                                      type="file"
                                      hidden
                                      onChange={(e) => {
                                        this.props.services.fileUpload.secretaryUploadDocument(achievement.document.id, e.target.files[0])
                                      }}
                                    />
                                    Обновить файл
                                  </Button>
                                </Box>
                              ) : (
                                <TextField
                                  label="Document File"
                                  type="file"
                                  variant="outlined"
                                  fullWidth
                                  InputLabelProps={{ shrink: true }}
                                  onChange={(e) => {
                                    this.props.services.fileUpload.uploadDocument(e.target.files[0], Constants.FILE_TYPES.achievementDocument, () => { })
                                      .then((response) => {
                                        this.setState((prevState) => {
                                          const achievementInfo = [...prevState.achievementInfo];
                                          achievementInfo[index].documentId = response.data;
                                        });
                                      })
                                  }}
                                />
                              )
                            }

                          </Grid>
                        </Grid>
                      </Grid>
                    </Box>
                  ))}
                  <Grid item md={9}>
                    <Button
                      variant="outlined"
                      color="primary"
                      style={{ width: "100%", marginTop: "20px", marginBottom: "20px" }}
                      onClick={() =>
                        this.setState((prevState) => ({
                          achievementInfo: [
                            ...(Array.isArray(prevState.achievementInfo) ? prevState.achievementInfo : []),
                            {
                              eventName: "",
                              documentName: "",
                              documentDate: "",
                            },
                          ],
                        }))
                      }
                    >
                      Добавить
                    </Button>
                  </Grid>

                </div>

                <Grid item md={9}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    onClick={this.handleSubmit}
                    disabled={this.state.isEditable}
                  >
                    Сохранить
                  </Button>
                </Grid>
              </form>
              <br />

              <AuthenticatedContent role={"ROLE_SECRETARY"}>
                {!this.state.isApproved && (
                  <>
                    <div style={{ alignItems: "center", padding: "10px" }}>
                      <TextField
                        fullWidth
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        label="Выберите нужную вам академическую степень"
                        onChange={(event) =>
                          this.handleSelectedAcademicDegree(event.target.value)
                        }
                        value={this.state.selectedAcademicDegree}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {this.state.academicDegrees.map((academicDegree) => (
                          <MenuItem
                            key={academicDegree.id}
                            value={academicDegree.id}
                          >
                            {academicDegree.name}
                          </MenuItem>
                        ))}
                      </TextField>
                    </div>

                    {this.state.selectedAcademicDegree && (
                      <div style={{ alignItems: "center", padding: "10px" }}>
                        <TextField
                          fullWidth
                          select
                          children
                          defaultValue=""
                          variant="outlined"
                          label="Выберите образовательную программу"
                          onChange={(event) =>
                            this.setState({
                              selectedEducationalProgram: event.target.value,
                            })
                          }
                          value={this.state.selectedEducationalProgram}
                        >
                          <MenuItem value="none" disabled>
                            Выберите один из вариантов
                          </MenuItem>
                          {this.state.educationalPrograms.map(
                            (educationalProgram) => (
                              <MenuItem
                                key={educationalProgram.id}
                                value={educationalProgram.id}
                              >
                                {educationalProgram.titleEn}
                              </MenuItem>
                            )
                          )}
                        </TextField>
                      </div>
                    )}

                    {this.state.selectedEducationalProgram && (
                      <div style={{ alignItems: "center", padding: "10px" }}>
                        <Button
                          type="submit"
                          variant="contained"
                          color="primary"
                          onClick={this.updateEducationalProgram}
                        >
                          Подтвердить выбор образовательной программы
                        </Button>
                      </div>
                    )}
                  </>
                )}
                <br />
                <Grid item md={9}>
                  <Grid container spacing={2}>
                    <Grid item xs={5} style={{ marginLeft: "10px" }}>
                      <Typography id="input-slider-1" gutterBottom>
                        Bar код
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography gutterBottom>{barCode}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <h2>Отправить сообщение на email</h2>
                <form onSubmit={(event) => this.sendMessageToEmail(event)}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "5px",
                    }}
                  >
                    <TextField
                      multiline
                      rows={4}
                      fullWidth
                      variant="outlined"
                      rowsMax={Infinity}
                      aria-label="minimum height"
                      // minRows={4}
                      style={{ marginLeft: "10px" }}
                      value={this.state.emailMessage}
                      onChange={(event) =>
                        this.setState({
                          emailMessage: event.target.value,
                        })
                      }
                    />
                    <Button
                      style={{ marginLeft: "10px" }}
                      type="submit"
                      variant="contained"
                      color="primary"
                      disabled={this.state.disableSendMessageButton}
                    >
                      Отправить
                    </Button>
                  </div>

                  {!this.state.isApproved && (
                    <div style={{ alignItems: "center", padding: "5px" }}>
                      <TextField
                        style={{
                          marginBottom: "10px",
                        }}
                        fullWidth
                        select
                        children
                        defaultValue=""
                        variant="outlined"
                        label="Выберите статус абитуриента"
                        onChange={(event) =>
                          this.setState({
                            enrolleeStatus: event.target.value,
                          })
                        }
                        value={this.state.enrolleeStatus}
                      >
                        <MenuItem value="none" disabled>
                          Выберите один из вариантов
                        </MenuItem>
                        {statuses.map((status) => (
                          <MenuItem key={status.id} value={status.id}>
                            {status.label}
                          </MenuItem>
                        ))}
                      </TextField>

                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        onClick={this.giveStatusToEnrollee}
                        disabled={!this.state.barCode}
                      >
                        Задать статус абитуриенту
                      </Button>
                    </div>
                  )}
                </form>
              </AuthenticatedContent>
            </Paper>
            <br />
            <br />
            {this.state.barCode && this.state.showApprove && (
              <Button
                type="submit"
                variant="contained"
                color="primary"
                onClick={this.isApproved}
                disabled={this.state.isApproved || this.state.isEditable}
              >
                Подтвердить абитуриента
              </Button>
            )}

            {this.state.isApproved && (
              <Typography>Данный пользователь уже подтвержден</Typography>
            )}
            {this.state.isApproved && (
              <ContractModal
                services={this.props.services}
                abiturInfo={this.state.abiturInfo}
                documents={this.state.documents}
                institutions={this.state.institutions}
              />
            )}
          </Grid>
        </Grid >
      </>
    );
  }
}

export default withServices()(SingleEnrolleePage);
